import { PageTopBar, ButtonLoader, DialogView, ConfirmDialog, PageView, FulfillmentErrorModal } from '../../../components'
import { useParams, useHistory, useLocation } from 'react-router-dom'
import { useState, useMemo, useRef, useEffect, useContext, useCallback } from 'react'
import { Loader } from '../../../components/Loader'
import { useDispatch, useSelector } from 'react-redux'
import { LabelView } from './LabelView'
import { UserContext } from '../../../hooks/UserContext'
import countryList from 'react-select-country-list'
import { getShipingLabels, getPackingPrintBundle } from '../../../services'
import { useHotkeys } from 'react-hotkeys-hook'
import { GENERATE_LABELS, GENERATE_ORDER_LABEL } from '../../../navigation/constants'
import { fetchSipSiblingByProduct } from '../../../services/pickingOrderServices'
import { carrierShippingLabels } from '../orderLabels'
import { SHIPPING_TYPES } from './sections/ShippingPackageDataSection/constants'
import { getReviewBlockMessage } from './packingReviewBlock'
import { codBlocksLabelGeneration } from '../../../utils/shippingMethodUtils'
import { pickTargetBox, isNotAContainer, orderContainsCode, productForUnitCode, withoutUnitCode } from './containerScan'
import { buildLabelPackages, withDerivedPackages } from './labelPackages'
import {
  requestRecording,
  stopRecording,
  recordingRequested as recordingRequestedSelector,
  lastStatus as lastStatusSelector,
  selectCameraSnapshot,
} from '../../../redux/webcamRecorderSlice'
import { CAMERA_ERROR_CODES, CAMERA_STATUS } from '../../../helpers/cameraStatusConstants'
import { CameraBlockedBanner } from './components/CameraBlockedBanner'
import { LabelPendingBanner } from './components/LabelPendingBanner'
import { CameraBlockedDialog } from './components/CameraBlockedDialog'
import { PackingAuditBanner } from './components/PackingAuditBanner'
import { PackingAuditQuestions } from './components/PackingAuditQuestions'
import { PackingAuditBlockedDialog } from './components/PackingAuditBlockedDialog'
import { useTranslation } from 'react-i18next'
import useCameraPreview from '../../../hooks/useCameraPreview'
import { useDraggable } from '../../../hooks/useDraggable'
import { isMobile } from 'react-device-detect'
import { RefreshIcon } from '@heroicons/react/outline'

import {
  orderShippingAddress,
  setShipmentData,
  setShippingAddress,
  setShippingDetails,
  setData,
  shipmentData,
  ordershippingDetails,
} from '../../../redux/createShipmentSlice'

import moment from 'moment'
import {
  fetchOrder,
  generateLabel,
  fetchGenerateLabelStatus,
  fetchPrerequisiteStatus,
  fetchWarehouseCubboShippingMethods,
  fetchOrderShippingPackages,
  fetchStoreConfig,
  fetchStorePackingOptions,
  getWarehousePackingMaterials,
  getStorePackingMaterials,
  getOrderPackageRestrictions,
  getOrderRecommendedShippingPackages,
  startPackingSession,
  getPackingSession,
  listPackingSessionsForOrder,
  openPackingBox,
  scanUnitIntoBox,
  bulkScanIntoBox,
  unscanUnit,
  bulkUnscanFromBox,
  reopenPackingBox,
  closePackingBox,
  getBoxPackingList,
  closePackingSession,
  updatePackingBoxShippingPackage,
  concludePackingSession,
  deletePackingBox,
  startPackingAudit,
} from '../../../services'

import { useQueryClient, useQuery } from 'react-query'
import { cloneDeep } from 'lodash'
import { ImeiDialog } from '../../../components/ImeiDialog'
import { UnitCodeDialog } from '../../../components/UnitCodeDialog'
import { CorreiosDialog } from '../../../components/CorreiosDialog'
import { PickingOrderToReviewDialog } from '../../../components/PickingOrderToReviewDialog'
import {
  MissingPickingPiecesSection,
  RecommendedPackageSection,
  ShippingPackageDataSection,
  FragileNotificationSection,
  InsertsSection,
  GenerateShipmentFooter,
  ProductListSection,
  ShippingLabelsListSection,
  AttachmentsListSection,
  ShippingAddressSection,
  CodNotificationSection,
  GeneratedLabelNotificationSection,
  MissingInfoNotificationSection,
  InternationalNotificationSection,
  MultiBoxPackingPanel,
  FulfillmentErrorBannerSection,
} from './sections'
import {
  validateIsPackagelessOrder,
  validateHasPackagelessProduct,
  validateIsFragileOrder,
  filterPrintableShippingDocuments,
  buildPrintSources,
  resolveBundleOutcome,
} from '../../../utils/orderUtils'
import { isSuperAdminUser, isWarehouseAdminUser, isBetaTesterUser } from '../../../utils/userUtils'
import { validateIsMultiPackageShippingMethod } from './sections/ShippingPackageDataSection/utils'
import { isProductionEnvironment } from '../../../helpers/environmentHelper'
import { resolveGenerateLabelErrorMessage, getBackendErrorMessage } from './errorMessages'
import { buildGenericPrintInfo } from './printInfo'
import { resolveSipOrderLine, resolveSipProductIdentifier } from './sipProductIdentifier'
import { capRequiredToAssignedUnits } from './requiredQuantities'
import { resolveUnitProductId as resolveUnitProductIdFor } from './unitProductResolution'
import { resolvePackingErrorMessage } from './packingErrorMessage'
import {
  canGenerateFirstLabel,
  isReemission,
  labelEmissionBlocked,
  pendingPiecesCount,
  closingLastBoxWithPending,
  bulkAddAllowed,
  isBulkAddDisabledError,
  backendSwitchesForMultiGuide,
} from './packingGates'
import {
  isTerminalOrderStatus,
  pickSessionForDisplay,
  shouldPollPackingSession,
  createBoxOpenGuard,
  shouldFocusScanInput,
  createBoxScanQueue,
  resolveActiveBoxId,
  applyScanResponse,
  scanWithReplay,
  countActiveParticipants,
  isJunkBox,
} from './packingSessionDisplay'

const PACKING_AUDIT_REQUIRED_CODE = 'packing_audit_required'
// Session-start failures that mean "the order isn't pack-ready YET" — normal
// lifecycle timing (median box-1 open → first scan is ~4 min; operators open
// the page while picking is still finishing), not an error. While one of these
// is the reason there's no session, the order is re-fetched on an interval so
// the block clears ON ITS OWN the moment the order reaches packing — the
// start effect keys on data?.status and nothing else refreshed the order while
// the operator waited, so the old block lasted until a page reload.
const BENIGN_SESSION_START_CODES = ['order_not_in_packing', 'order_in_picking', 'order_in_processing', 'order_not_found']
const SESSION_START_RETRY_POLL_MS = 5000
// How often to ask whether a pending label PDF has landed. 3s matches the cadence the rest
// of this screen already polls at, and is well under the 17s median the PDF actually takes.
const LABEL_PENDING_POLL_MS = 3000
// Headless UI re-focuses the empaque combobox input on the animation frame after
// an option is picked. Handing the focus to the scan input must run after that
// frame, or the combobox wins and the next scan types into the empaque filter.
const SCAN_INPUT_FOCUS_DELAY_MS = 50

export const parseRecordingOrderId = routeId => (/^\d+$/.test(routeId) ? Number.parseInt(routeId, 10) : null)

const MINI_PREVIEW_W = 160
const MINI_PREVIEW_H = 90

export const GenerateShipment = () => {
  const queryClient = useQueryClient()
  const shippingAddress = useSelector(orderShippingAddress)
  const shippingDetails = useSelector(ordershippingDetails)
  // Mirror the latest shippingDetails for effects whose deps don't include
  // it but still need to merge into the Redux store without overwriting
  // unrelated keys with a stale closure snapshot.
  const shippingDetailsRef = useRef(shippingDetails)
  useEffect(() => {
    shippingDetailsRef.current = shippingDetails
  }, [shippingDetails])
  const shipment = useSelector(shipmentData)
  // Rollbacks run from older closures (retried scans, async catches); they read this.
  const shipmentRef = useRef(shipment)
  shipmentRef.current = shipment
  const { warehouse_id } = useParams()
  const [loadingButtonLoader, setLoadingButtonLoader] = useState(false)
  const [errorMessage, setErrorMessage] = useState(null)
  const [fulfillmentError, setFulfillmentError] = useState(null)
  // Set when generate answers 202: the label exists at the carrier, its PDF is still
  // downloading. Holds the polling key so the effect below can finish the job unattended.
  const [labelPending, setLabelPending] = useState(null)
  const [trackingNumber, setTrackingNumber] = useState(null)
  const [pickingOrder, setPickingOrder] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)
  const [openWarningDialog, setOpenWarningDialog] = useState(false)
  const [warningDialogCode, setWarningDialogCode] = useState(null)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [shippingLabel, setShippingLabel] = useState({})
  const [printInformation, setPrintInformation] = useState(false)
  const [openDialogDocument, setOpenDialogDocument] = useState(false)
  const [openDialogImei, setOpenDialogImei] = useState(false)
  const [openDialogRevertPacking, setOpenDialogRevertPacking] = useState({ show: false, eraseShippingData: false })
  // A send to review that failed after the server may have cleared the multi-box bench: the
  // counts on this screen are stale, so closing the dialog reloads the page from the server.
  const reloadAfterReviewDialogRef = useRef(false)
  const closeReviewDialog = () => {
    setOpenDialogRevertPacking({ ...openDialogRevertPacking, show: false })
    if (reloadAfterReviewDialogRef.current) window.location.reload()
  }
  const [openDialogCorreios, setOpenDialogCorreios] = useState(false)
  const [reviewedProductId, setReviewedProductId] = useState(null)
  // Original product code (SKU/UPC/bar_code) captured when the IMEI dialog
  // opens — we need to send it to /scan together with the IMEI so the
  // backend can resolve the product before resolving the unit.
  const [reviewedProductCode, setReviewedProductCode] = useState(null)
  const [shippingDocuments, setShippingDocuments] = useState([])
  const [extraShippingLabels, setExtraShippingLabels] = useState([])
  const [alert, setAlert] = useState(false)
  const [latestAddedProduct, setLatestAddedProduct] = useState(null)
  const [packageFocusSignal, setPackageFocusSignal] = useState(0)
  const [requiresZipcode, setRequiresZipcode] = useState(true)
  const [initShippingDetails, setInitShippingDetails] = useState(false)
  const history = useHistory()
  const dispatch = useDispatch()
  const { id } = useParams()
  const [bulkAddRevoked, setBulkAddRevoked] = useState(false)
  // The router reuses this instance across orders; a revoke must not leak to the next one.
  useEffect(() => setBulkAddRevoked(false), [id])
  const recordingOrderId = parseRecordingOrderId(id)
  const { user } = useContext(UserContext)
  const options = useMemo(() => countryList().getData(), [])
  const [productsToReviewById, setProductsToReviewById] = useState({})
  const [loading, setLoading] = useState(false)
  const [busyPackageSelection, setBusyPackageSelection] = useState(false)
  const [packingSessionId, setPackingSessionIdState] = useState(null)
  // Removed write-only `packingSessionError`. Session/box errors now route
  // through the existing `errorMessage` red-bar so the operator sees them
  // (peek/create silently failing was the root cause behind several
  // "nothing happens when I scan" reports).
  const [activeBoxId, setActiveBoxIdState] = useState(null)
  // Ref mirror of activeBoxId, updated synchronously inside setActiveBoxId so
  // that handlers running BEFORE the next render (e.g. the scanner firing
  // right after a pill click) read the latest selection, not the closure.
  const activeBoxIdRef = useRef(null)
  const setActiveBoxId = id => {
    activeBoxIdRef.current = id
    setActiveBoxIdState(id)
  }
  // Same mirror for the session id: the scan input memoizes its handler, so a
  // closure built before the session existed would keep a null id for good.
  const packingSessionIdRef = useRef(null)
  const setPackingSessionId = id => {
    packingSessionIdRef.current = id
    setPackingSessionIdState(id)
  }
  const openingBoxRef = useRef(false)
  // Serializes the decrement-side effect (Paquetes "-") so rapid clicks
  // don't fire overlapping async IIFEs that double-close boxes.
  const closingBoxesRef = useRef(false)
  // Guards the lazy box-open lifecycle: at most one POST /boxes in flight per
  // next-slot (StrictMode double-invoke / fast dep changes), and IN-FLIGHT-ONLY
  // so a box freed by a close/delete can be re-opened with the same empaque
  // (CUBBO-2440 d). Lazily initialized so the ref keeps one guard across renders.
  const boxOpenGuardRef = useRef(null)
  if (!boxOpenGuardRef.current) boxOpenGuardRef.current = createBoxOpenGuard()
  // ONE /scan in flight per caja — see createBoxScanQueue. Lazily initialized
  // so the ref keeps one queue across renders.
  const scanQueueRef = useRef(null)
  if (!scanQueueRef.current) scanQueueRef.current = createBoxScanQueue()
  // Bumped by handlers whose outcome changes nothing observable (re-picking the
  // same empaque) but that must still hand the focus back to the scan input.
  const [scanFocusNonce, setScanFocusNonce] = useState(0)
  const requestScanFocus = () => setScanFocusNonce(n => n + 1)
  // How many of the cards' OWN confirm dialogs (reopen / delete caja — state
  // local to PaqueteCard) are open right now. The scan-focus rule reads this
  // through hasBlockingOverlay: without it the rule can't see those modals, so
  // it would fight their focus trap while open and never retry the handoff
  // once they close (its deps never changed). Count, not boolean — several
  // cards exist and each reports independently.
  const [cardDialogOpenCount, setCardDialogOpenCount] = useState(0)
  // Stable identity: PaqueteCard subscribes/unsubscribes in an effect keyed on
  // this callback.
  const handleCardDialogOpenChange = useCallback(open => {
    setCardDialogOpenCount(c => Math.max(0, c + (open ? 1 : -1)))
  }, [])
  // Why the packing session could not be started (backend `code`), or null.
  // While set — and until a session exists — scans are refused with an alert
  // instead of being counted locally and silently queued.
  const [sessionStartBlockedCode, setSessionStartBlockedCode] = useState(null)
  // Re-arms the lazy box-open lifecycle when a POST left the box count unchanged.
  const [boxOpenSignal, setBoxOpenSignal] = useState(0)
  const [restoredPackagesSnapshot, setRestoredPackagesSnapshot] = useState(null)
  const [productsRestoredFromSession, setProductsRestoredFromSession] = useState(false)
  // Bumped whenever we modify shippingDetails.packages from OUTSIDE
  // ShippingPackageDataSection (e.g., "Eliminar caja" decrement) — forces
  // a remount of the section so its internal state re-syncs with Redux.
  const [packagesExternalVersion, setPackagesExternalVersion] = useState(0)
  // Track previous packages length so we can detect operator decrements
  // (clicking "-" on Paquetes) and close matching empty boxes on backend.
  const prevPackagesLengthRef = useRef(null)
  // Holds scans that arrived before the session / first open box were
  // ready. Drained by the effect below as soon as both become available.
  const pendingScansRef = useRef([])
  // The caja the operator just opened (picked its empaque on the "+ Añadir otra
  // caja" slot). The lazy-open effect sets it; the active-caja effect adopts it
  // as soon as the session cache brings the box — setting it straight after the
  // POST raced React Query's notification and the auto-pick snapped back to the
  // first open caja.
  const pendingActiveBoxIdRef = useRef(null)
  const pendingContainerScansRef = useRef([])
  const containerScanInFlightRef = useRef(false)
  // One-shot flag: true once we've peeked for an existing open session for
  // this order. Gates the create-session effect so it doesn't POST until
  // we've confirmed no open session already exists.
  const [sessionLookupDone, setSessionLookupDone] = useState(false)
  // True only when we ATTACHED to a session that already had progress
  // (found via lookup), as opposed to creating a brand-new one. Used to
  // gate the snapshot restore — newly created sessions must not be
  // hijacked into "restoring" while their boxes are still being opened.
  const [attachedToExistingSession, setAttachedToExistingSession] = useState(false)
  // Tracks which box ids have a /close request in flight. Survives card
  // remounts caused by the reorder (open at top, closed at bottom) — the
  // PaqueteCard's local closingInFlight is lost across remount, so a
  // double-click on a card that just transitioned slots could otherwise
  // fire a second /close on a box that is already closed.
  const closingBoxIdsRef = useRef(new Set())
  // Closing the last open caja with pieces pending asks first (BUGS-8259). The
  // question goes through the project's ConfirmDialog like every other confirm in
  // this panel, which means it cannot be answered inline the way window.confirm
  // was: the close has to survive as a callable until the operator answers. The
  // ref holds that continuation, the state drives the dialog.
  const [lastBoxCloseConfirm, setLastBoxCloseConfirm] = useState(null)
  const pendingCloseRunnerRef = useRef(null)
  // Optimistic placeholders for in-flight scans, kept OUTSIDE the React
  // Query cache. The cache is wholesale-replaced on every polling refetch
  // (every 3s) or invalidate; if placeholders lived there they'd be wiped
  // before the server confirms the scan → row flickers "appear → disappear
  // → reappear". Keeping them here makes them immune to cache refreshes.
  // Shape: { [boxId]: [{ id, sku, product_id, product_code }] }
  const [optimisticUnitsByBoxId, setOptimisticUnitsByBoxId] = useState({})
  const [auditLocallyAnswered, setAuditLocallyAnswered] = useState(false)
  const [packingAuditBlocked, setPackingAuditBlocked] = useState(false)
  const auditStartPingedRef = useRef(false)

  const cameraRecordingRequested = useSelector(recordingRequestedSelector)
  const cameraLastStatus = useSelector(lastStatusSelector)
  const cameraSnapshot = useSelector(selectCameraSnapshot)
  const [cameraBlockedMessage, setCameraBlockedMessage] = useState(null)
  const [isRetryingCamera, setIsRetryingCamera] = useState(false)
  const cameraRetryTimerRef = useRef(null)
  const {
    videoRef: miniPreviewRef,
    isReady: miniPreviewIsReady,
    error: miniPreviewError,
    retry: retryMiniPreview,
    isRetrying: isMiniPreviewRetrying,
    isDenied: miniPreviewIsDenied,
  } = useCameraPreview()
  const { position: previewPosition, isDragging: previewIsDragging, dragHandleProps: previewDragHandleProps } = useDraggable(MINI_PREVIEW_W, MINI_PREVIEW_H)

  const search_params = useLocation().search
  const inhereted_exclude_picking_order_ids_string = new URLSearchParams(search_params).get('exclude_picking_order_ids')
  const inhereted_exclude_picking_order_ids = inhereted_exclude_picking_order_ids_string ? inhereted_exclude_picking_order_ids_string.split(',') : []
  const inputRef = useRef()
  const previousValidQualityCheck = useRef(false)
  const [imeiRegex, setImeiRegex] = useState(null)
  const [openDialogUnitCode, setOpenDialogUnitCode] = useState(false)
  const [unitCodeReviewedProductId, setUnitCodeReviewedProductId] = useState(null)
  const [unitCodeAllowed, setUnitCodeAllowed] = useState([])
  const { i18n } = useTranslation()
  const { isLoading, isPreviousData, isFetchedAfterMount, isError, error, data } = useQuery(`order-${id}`, () => fetchOrder(id), {
    onSuccess: info => {
      if (isFetchedAfterMount === false) {
        setOrderData(info)
      }
    },
  })

  const isEditAllowed = useMemo(() => data?.can_order_be_edited?.allowed ?? true, [data])
  const editRestrictionReason = useMemo(() => data?.can_order_be_edited?.reason, [data])
  const canEditShippingMethod = useMemo(() => user?.permissions?.wms_edit_shipping_method || isSuperAdminUser(user) || isWarehouseAdminUser(user), [user])

  // Packing audit (§8): `data.packing_audit` is null unless the order was selected
  // for audit. `required` is true only while the audit is still `pending`.
  const packingAudit = data?.packing_audit
  const auditRequired = packingAudit?.required === true
  const auditCritical = packingAudit?.selection_reason === 'critical_client'

  const {
    isLoading: warehousePackingMaterialsIsLoading,
    isPreviousData: warehousePackingMaterialsIsPreviousData,
    isError: warehousePackingMaterialsIsError,
    error: warehousePackingMaterialsError,
    data: warehousePackingMaterialsData,
  } = useQuery(['warehouse-packing-materials', warehouse_id], () => getWarehousePackingMaterials(warehouse_id))

  const {
    isLoading: storePackingMaterialsIsLoading,
    isPreviousData: storePackingMaterialsIsPreviousData,
    isError: storePackingMaterialsIsError,
    error: storePackingMaterialsError,
    data: storePackingMaterialsData,
  } = useQuery(['warehouse-packing-materials', warehouse_id, data?.store?.id], () => getStorePackingMaterials(warehouse_id, data?.store?.id), {
    enabled: data ? true : false,
  })

  const {
    isLoading: isLoadingImeiValidationConfiguration,
    isError: isErrorImeiValidationConfiguration,
    error: ImeiValidationConfigurationError,
    data: imeiValidationConfiguration,
  } = useQuery(['imei_validation_regex', data?.store?.id], () => fetchStoreConfig(data.store.id, 'imei_validation_regex'), {
    enabled: !!data,
  })

  const {
    isLoading: isLoadingOrderPackageRestrictions,
    isError: isErrorOrderPackageRestrictions,
    error: errorOrderPackageRestrictions,
    data: orderPackageRestrictions,
  } = useQuery(['order-package-restrictions', data?.id], () => getOrderPackageRestrictions(data.id), {
    enabled: !!data,
  })

  const {
    isLoading: isLoadingOrderRecommendedShippingPackages,
    isError: isErrorOrderRecommendedShippingPackages,
    error: errorOrderRecommendedShippingPackages,
    data: orderRecommendedShippingPackages,
  } = useQuery(['order-recommended-shipping-packages', data?.id], () => getOrderRecommendedShippingPackages(data.id), {
    enabled: !!data,
  })

  const cubboShippingMethods = useQuery('cubbo_shipping', () => fetchWarehouseCubboShippingMethods(warehouse_id))

  const shippingPackages = useQuery(`order_shipping_packages-${id}`, () => fetchOrderShippingPackages(id))

  const {
    isLoading: isLoadingPackingOptions,
    isError: isErrorPackingOptions,
    error: packingOptionsError,
    data: packingOptions,
  } = useQuery(['packing_options', data?.store?.id], () => fetchStorePackingOptions(data.store.id), { enabled: !!data?.store })

  useEffect(() => {
    const autofocusSearchInput = () => {
      let focusTimer = null

      if (!inputRef.current) {
        focusTimer = setTimeout(() => autofocusSearchInput(), 50)
      } else {
        inputRef.current?.focus()
      }

      return focusTimer
    }

    let focusTimer = null

    if (!isLoading && !openWarningDialog && !openDialogImei && !openDialogUnitCode && !warehousePackingMaterialsIsLoading && !storePackingMaterialsIsLoading) {
      focusTimer = autofocusSearchInput()
    }

    return () => {
      if (focusTimer) {
        return clearTimeout(focusTimer)
      }
    }
  }, [shipment, isLoading, openWarningDialog, openDialogImei, openDialogUnitCode, warehousePackingMaterialsIsLoading, storePackingMaterialsIsLoading])

  useEffect(() => {
    if (data?.meli_shipment_id && shippingLabel?.label_file) {
      const searchParamsLabel = {
        order_id: id,
        carrier_name: 'Mercado Envíos',
        status: 'VALID',
      }
      getExtraShippingLables(searchParamsLabel)
    }
  }, [shippingLabel])

  useEffect(() => {}, [extraShippingLabels])

  useEffect(() => {
    if (isProductionEnvironment && recordingOrderId !== null) {
      dispatch(requestRecording(recordingOrderId))
    }
  }, [dispatch, recordingOrderId])

  // Reset packing-audit session state when the order changes. The component is
  // NOT remounted when navigating to the next order in a tote (same route, new
  // :id — see goToNextOrderInTote), so without this the previous order's
  // "answered"/"pinged" flags would leak and silently skip the next order's audit.
  useEffect(() => {
    setAuditLocallyAnswered(false)
    setPackingAuditBlocked(false)
    auditStartPingedRef.current = false
  }, [id])

  const shouldBlockPreventively = useMemo(() => {
    if (!isProductionEnvironment) return false
    if (!data?.requires_packing_camera) return false
    const recordingIsActive =
      cameraRecordingRequested === true && (cameraLastStatus === CAMERA_STATUS.RECORDING_STARTED || cameraLastStatus === CAMERA_STATUS.UPLOAD_CHUNK_FAILED)
    return !recordingIsActive
  }, [data?.requires_packing_camera, cameraRecordingRequested, cameraLastStatus])

  const hasBlockingOverlay =
    shouldBlockPreventively ||
    openConfirmDialog ||
    openWarningDialog ||
    openDialogImei ||
    openDialogUnitCode ||
    openDialogCorreios ||
    openDialogDocument ||
    openDialogRevertPacking.show ||
    // Confirms owned by the paquete cards (reopen / delete) — reported upward
    // because their open state lives in PaqueteCard, not here.
    cardDialogOpenCount > 0

  const handleRetryCamera = useCallback(() => {
    if (cameraRetryTimerRef.current) return
    setIsRetryingCamera(true)
    setErrorMessage(null)
    dispatch(stopRecording())
    cameraRetryTimerRef.current = setTimeout(() => {
      cameraRetryTimerRef.current = null
      if (recordingOrderId !== null) dispatch(requestRecording(recordingOrderId))
      setCameraBlockedMessage(null)
      setIsRetryingCamera(false)
    }, 500)
  }, [dispatch, recordingOrderId])

  useEffect(
    () => () => {
      setCameraBlockedMessage(null)
      if (cameraRetryTimerRef.current) {
        clearTimeout(cameraRetryTimerRef.current)
        cameraRetryTimerRef.current = null
        setIsRetryingCamera(false)
      }
    },
    [recordingOrderId],
  )

  useEffect(() => {
    if (orderPackageRestrictions && orderRecommendedShippingPackages && !initShippingDetails) {
      // Skip when there's already an active packing session with backend
      // boxes. The restore effect handles that case and sets
      // packages_count from the live boxes; running the legacy init here
      // would overwrite it back to the order's package_quantity (often
      // 1) and break the multi-box panel sync (PAQUETE 12 placeholder
      // disappears, "Selecciona empaque" detection fails, etc.).
      // Pull packing_session straight from the cache so this effect can
      // reference it before useQuery declares the variable downstream.
      if (packingSessionId) {
        const cachedSession = queryClient.getQueryData(['packingSession', packingSessionId])
        if (cachedSession?.packing_boxes?.length > 0) {
          setInitShippingDetails(true)
          return
        }
      }
      const newPackageCount = orderPackageRestrictions.package_quantity ? orderPackageRestrictions.package_quantity : shippingDetails.packages_count
      const newShippingPackages =
        orderRecommendedShippingPackages.shipping_packages && orderRecommendedShippingPackages.shipping_packages.length > 0
          ? [...orderRecommendedShippingPackages.shipping_packages]
          : shippingDetails.packages

      dispatch(
        setShippingDetails({
          ...shippingDetails,
          packages_count: newPackageCount,
          packages: newShippingPackages,
        }),
      )
      setInitShippingDetails(true)
    }
  }, [dispatch, initShippingDetails, orderPackageRestrictions, shippingDetails, orderRecommendedShippingPackages, packingSessionId, queryClient])

  const isPackagelessOrder = useMemo(() => validateIsPackagelessOrder(data?.order_lines), [data])
  const isFragileOrder = useMemo(() => validateIsFragileOrder(data?.order_lines), [data])
  const hasPackagelessProduct = useMemo(() => validateHasPackagelessProduct(data?.order_lines), [data])
  // Only real carrier guides (Shipping / Cash On Delivery, VALID). The packing
  // list is persisted as a Pickup label and must never be mistaken for a guide.
  // Shared with the shipped-orders list (hasCarrierShippingLabel) and mirrors the
  // backend OrderPolicy#generate_label? additional-guide gate.
  const carrierLabels = useMemo(() => carrierShippingLabels(data?.shipping_labels), [data])

  // Counts ANY label (incl. the Pickup packing list) on purpose: once an order is
  // shipped/returned it enters "invalidate previous labels" / reprint mode, and the
  // packing list is exactly what an external-guide / warehouse-pickup order reprints
  // here — so this is deliberately broader than the carrierLabels guide check above.
  const alreadyHasLabels = useMemo(() => data?.shipping_labels?.length > 0 && ['shipped', 'returned', 'returning'].includes(shipment?.status), [data, shipment])

  // True when the order is still in packing but its only valid carrier label(s)
  // were completed by the FM async fallback (async_generated). In that state the
  // synchronous generation timed out and raised before the order could advance
  // to shipped, leaving a complete-but-orphaned label. Re-clicking "generate
  // label" idempotently reuses the existing label and finishes the order, so we
  // surface the emitted labels and allow the action even for operators that lack
  // the elevated generate_additional_labels permission. Scoped to carrierLabels:
  // the always-present Pickup packing list is not async_generated, so counting it
  // here would defeat the every()-waiver and re-block the very operators this
  // exists for. Mirrors the backend, which scopes the same waiver to carrier labels.
  const asyncGeneratedPendingLabels = useMemo(() => {
    return shipment?.status === 'packing' && carrierLabels.length > 0 && carrierLabels.every(label => label.async_generated)
  }, [carrierLabels, shipment])

  // async_generated is set at handoff to the async fallback, BEFORE the PDF
  // exists (CUBBO-2149) — so a pending label may have no file yet. Only offer
  // the reprint section once a file is actually attached; until then a
  // "being generated" hint renders instead. Scoped to carrierLabels: a Pickup
  // packing list always has a file, so checking any VALID label would reveal the
  // reprint section before the recovering carrier PDF is actually attached.
  const asyncGeneratedPrintableLabels = useMemo(() => {
    if (!asyncGeneratedPendingLabels) return false
    return carrierLabels.some(label => label.label_file)
  }, [carrierLabels, asyncGeneratedPendingLabels])

  // Gates on the Redux copy on purpose: the derivation below is declared after
  // this memo. The lists can disagree — dimensions are nullable — but the backend
  // re-reads each package from its own row by id and only trusts the sent values
  // for `packageless`, where it rejects a non-positive one with a visible 422. So
  // a split verdict cannot ship an unusable package.
  const areShippingPackagesValid = useMemo(() => {
    console.log('areShippingPackagesValid', shippingDetails?.packages)
    if (!shippingDetails?.packages || shippingDetails.packages.length <= 0) {
      return false
    }

    return shippingDetails.packages.every(shippingPackage => {
      if (!shippingPackage) {
        return false
      } else if (!parseInt(shippingPackage.length_cm) || !parseInt(shippingPackage.width_cm) || !parseInt(shippingPackage.height_cm)) {
        return false
      } else if (!parseFloat(shippingPackage.weight_kg) || !parseFloat(shippingPackage.volumetric_weight)) {
        return false
      }

      return true
    })
  }, [shippingDetails])

  const isInternationalOrder = useMemo(() => {
    const warehouseCountry = user.current_warehouse?.country
    return warehouseCountry !== shippingAddress.country.value
  }, [shippingAddress, user.current_warehouse?.country])

  // Every refusal that must happen BEFORE the guide is requested, in one place, returning the
  // i18n key of the reason or null when generation may proceed. Extracted because this screen
  // has two entry points and only one of them ran these checks: the ctrl+g hotkey hand-rolled
  // the confirm step alone and reached the backend with none of them run, so a COD order left
  // on a method that cannot collect came back as a raw CODE_SHIPPING_METHOD_INVALID string and
  // persisted an ACTIVE OrderFulfillmentError flagged to the merchant — for something the
  // merchant did not cause and cannot fix. One gate, one message, one place to change next time.
  const generationBlockedReason = () => {
    if (data && data.status === 'picking') return 'generate_shipment.picking_incomplete'

    // Not for an order the backend switches by itself: refusing here kept it from ever reaching
    // that switch, and left no record of the block when the backend would have refused anyway.
    if (
      effectiveShippingDetails?.packages_count > 1 &&
      shippingDetails?.shippingMethod?.shipping_type !== SHIPPING_TYPES.PICKUP &&
      !shippingDetails?.shippingMethod?.enable_multipackage &&
      !backendSwitchesForMultiGuide(data)
    )
      return 'generate_shipment.no_multiple_packages'

    // Capability, not identity. The backend accepts a collect order on any method whose
    // emission Cubbo makes — not only on a dedicated is_cod method — so checking is_cod here
    // blocked in the browser what all of the backend's gates accept, and the request never
    // left. That is what kept Chile from packing a cash-on-delivery order at all: Blue
    // Express collects on its ordinary method, with no COD twin.
    if (codBlocksLabelGeneration(data, shippingDetails?.shippingMethod)) return 'generate_shipment.cod_not_allowed'

    return null
  }

  // When the card's countdown reaches zero, we ask the server what its re-trigger
  // cycle did in the meantime. Three possible answers: it is done and the
  // operator can retry; the cycle opened another round, and then the card starts
  // a new clock with the new attempt number; or the attempts ran out and the case
  // went to Tech, which the card already knows how to paint.
  const handleWaitElapsed = useCallback(async () => {
    if (!id) return

    try {
      const prerequisite = await fetchPrerequisiteStatus(id)

      if (prerequisite?.status === 'ready' || prerequisite?.status === 'unknown') {
        // Nothing to wait for: the clock is cleared and the button becomes available.
        setFulfillmentError(prev => (prev ? { ...prev, retryAfterSeconds: null, nextCheckAt: null } : prev))
        return
      }

      setFulfillmentError(prev =>
        prev
          ? {
              ...prev,
              code: prerequisite.fulfillment_error_code ?? prev.code,
              category: prerequisite.fulfillment_error_category ?? prev.category,
              responsibleArea: prerequisite.fulfillment_error_responsible_area ?? prev.responsibleArea,
              flagType: prerequisite.fulfillment_error_flag_type ?? prev.flagType,
              message: prerequisite.error ?? prev.message,
              summary: prerequisite.fulfillment_error_summary ?? prev.summary,
              detail: prerequisite.fulfillment_error_detail ?? prev.detail,
              retryAfterSeconds: prerequisite.fulfillment_error_retry_after_seconds ?? null,
              nextCheckAt: prerequisite.fulfillment_error_next_check_at ?? null,
              retryCount: prerequisite.fulfillment_error_retry_count ?? prev.retryCount,
              maxRetries: prerequisite.fulfillment_error_max_retries ?? prev.maxRetries,
            }
          : prev,
      )
    } catch (e) {
      // If the request fails, the button is released: leaving it locked forever over a
      // network problem would be worse than a retry that may fail again.
      setFulfillmentError(prev => (prev ? { ...prev, retryAfterSeconds: null, nextCheckAt: null } : prev))
    }
  }, [id])

  const handleGenerateLabel = async () => {
    // The label already exists at the carrier and its PDF is on its way; the poll will
    // print it. Re-clicking here is the habit the old error message taught, and it is
    // what produced the multi-event orders in order_fulfillment_errors.
    if (labelPending) return

    setLoading(false)

    const blockedReason = generationBlockedReason()
    if (blockedReason) {
      // picking_incomplete keeps its window.alert and its `return true`, unchanged: it is
      // the one refusal the operator has to acknowledge before the screen moves under
      // them, and the caller reads that truthy return. Swapping it for the inline message
      // would make the most consequential refusal the easiest one to miss.
      if (blockedReason === 'generate_shipment.picking_incomplete') {
        window.alert(i18n.t(blockedReason))
        return true
      }
      setErrorMessage(i18n.t(blockedReason))
      return
    }

    if (
      shippingDetails.shippingMethod.carrier_name === 'CORREIOS' &&
      (shippingDetails.shippingMethod.contract_provider === null || shippingDetails.shippingMethod.contract_provider === 'CORREIOS_PREPAID')
    ) {
      setOpenDialogCorreios(true)
    } else {
      setOpenConfirmDialog(true)
    }
    setErrorMessage(null)
  }
  const setOrderData = info => {
    if (info.shipping.country == null || info.shipping.country === '') {
      info.shipping.country = 'Mexico'
    }
    setPickingOrder(info.picking_order)
    const index = options.findIndex(country => country.label === info.shipping.country || country.value === info.shipping.country)
    const documents = info.hide_boleto ? info.shipping_documents.filter(doc => !doc.file?.filename?.startsWith('boleto_')) : info.shipping_documents
    setShippingDocuments([...documents])
    setRequiresZipcode(info.requires_zipcode !== false)
    let orderZipcode = info.shipping.zip_code || ''
    orderZipcode = orderZipcode.replace(/[^a-zA-Z0-9 \-]/g, '')
    dispatch(
      setData({
        shipment: {
          orderId: info.id,
          status: info.status,
          warehouseId: info.warehouse_id,
          order_number: info.order_number,
          store_name: info.store.name,
          store_id: info.store.id,
          tote: !info.uses_picking_tasks && info.picking_order ? info.picking_order.tote.unique_code : '',
          productsData: [],
        },
        pickingOrder: {
          id: info.picking_order ? info.picking_order.id : null,
        },
        shippingAddress: {
          status: 'editing',
          firstName: info.shipping.first_name || '',
          lastName: info.shipping.last_name || '',
          phone: info.shipping.phone || '',
          email: info.shipping.email || '',
          address: info.shipping.address_1 || '',
          address2: info.shipping.address_2 || '',
          country: options[index] || { id: 'MXN', name: 'MXN' },
          city: info.shipping.city || '',
          province: info.shipping.state || '',
          zipCode: orderZipcode,
          number: info.shipping.number || '',
          references: info.shipping.references || '',
        },
        shippingDetails: {
          shippingMethod: info.shipping_method,
          shippingDate: moment().format('YYYY-MM-DD'),
          description: '',
          packages: [],
          packages_count: 1,
        },
        itmes: info.order_lines,
      }),
    )

    let productsById = {}
    const nonScannableOrderLines = []
    info.order_lines.forEach(orderLine => {
      if (orderLine.product?.is_scannable) {
        if (orderLine.product?.is_kit && orderLine.product?.kit_childs?.length) {
          // kit_childs are relationships between kits (parent product) and the kit's children (child product)
          orderLine.product.kit_childs.forEach(kit_child => {
            if (!kit_child.child_product?.is_dropshipping) {
              if (kit_child.child_product.is_scannable) {
                productsById = increaseProductQuantity(productsById, kit_child.child_product, kit_child.quantity * orderLine.quantity)
              } else {
                nonScannableOrderLines.push(orderLine)
              }
            }
          })
        } else {
          productsById = increaseProductQuantity(productsById, orderLine.product, orderLine.quantity)
        }
      } else {
        nonScannableOrderLines.push(orderLine)
      }
    })

    setProductsToReviewById(capRequiredToAssignedUnits(productsById, info.order_lines))
  }

  const increaseProductQuantity = function (productsById, product, quantity = 1) {
    if (!productsById[product.id]) productsById[product.id] = product

    const currentQuantity = productsById[product.id].quantity
    productsById[product.id].quantity = currentQuantity ? currentQuantity + quantity : quantity

    return productsById
  }

  const getExtraShippingLables = async searchParamsLabel => {
    try {
      const response = await getShipingLabels(searchParamsLabel)
      const extra_shipping_labels = response.shipping_labels.filter(shipping_label => shipping_label.id !== shippingLabel.id)
      setExtraShippingLabels(extra_shipping_labels)
    } catch (e) {
      setErrorMessage(e?.response?.data?.error)
    }
  }

  // The success tail of a generate: takes `{ shipping_label, shipping_labels }` and drives
  // the print cascade. Shared by the synchronous 201 and by the 202 polling path below, so
  // a label whose PDF landed a few seconds late prints exactly like one that was ready
  // immediately — same documents, same bundle-vs-cascade decision, same suppression set.
  const completeGenerateLabel = async response => {
    setShippingLabel(response.shipping_label)
    await queryClient.invalidateQueries(`order-${id}`)
    setTimeout(() => {
      setOpenConfirmDialog(false)
      setConfirmLoading(false)

      // Build the suppression set from fresh labels: this closure was
      // created with the pre-generation `data`, so in the multi-OS
      // conversion flow the freshly minted VALID labels are missing
      // from it. The order query was just invalidated (and refetched)
      // above, so its cache entry is current; fall back to the generate
      // response and finally to the stale `data` default.
      const freshOrder = queryClient.getQueryData(`order-${id}`)
      // `shippingDocuments` was seeded only on the initial mount, but the
      // external guide (a printing_type 'label' document) is often created
      // DURING generate (tiktokshop/shein/walmart/anymarket). Refresh from
      // the just-refetched order so the cascade queues the guide instead of
      // closing the order without it; sync state so the later cascade sees it.
      const freshDocuments = freshOrder?.shipping_documents
        ? freshOrder.hide_boleto
          ? freshOrder.shipping_documents.filter(doc => !doc.file?.filename?.startsWith('boleto_'))
          : freshOrder.shipping_documents
        : shippingDocuments
      setShippingDocuments([...freshDocuments])
      const nonPrintedDocuments = shippingDocumentsToBePrinted(freshOrder?.shipping_labels ?? response.shipping_labels, freshDocuments)

      const startPerDocumentCascade = () => {
        if (response.shipping_label?.label_file?.path) print(i18n.t('generate_shipment.print_label'), response.shipping_label.label_file.path, 'label')
        else if (nonPrintedDocuments.length) printShippingDocument(nonPrintedDocuments[0], freshDocuments)
      }

      if (singleClickPrintEnabled) {
        printBundles(freshOrder?.shipping_labels ?? response.shipping_labels, freshDocuments, response.shipping_label, startPerDocumentCascade)
      } else {
        startPerDocumentCascade()
      }

      setLoading(false)
    }, 500)
  }

  // Finishes a generate that answered 202. FM Transportes hands the label PDF to a
  // background worker whenever it is not immediately downloadable; measured in production,
  // the PDF lands in 17s at p50 and inside a minute 94.9% of the time. Polling it here is
  // what turns that into a wait the operator watches resolve, instead of an error message
  // answered by clicking generate again — the loop that put 36k records a quarter in
  // order_fulfillment_errors, none of which anyone ever acted on.
  useEffect(() => {
    if (!labelPending?.transactionKey) return undefined

    let cancelled = false

    const check = async () => {
      let result
      try {
        result = await fetchGenerateLabelStatus(id, labelPending.transactionKey)
      } catch (e) {
        // A dropped poll is not a failed label: the next tick asks again. Only the
        // server's own verdicts (ready / failed / unknown) end the wait.
        return
      }
      if (cancelled) return

      if (result.ready) {
        setLabelPending(null)
        await completeGenerateLabel(result.label)
        return
      }

      if (result.failed) {
        // The carrier never produced the PDF. Now it is a real error, and the backend
        // has already recorded it against last mile with the tracking code attached.
        setLabelPending(null)
        setLoading(false)
        // Same rule as the synchronous catch below: only a categorized error (one that carries
        // fulfillment_error_code) opens the card. An uncategorized one goes to the red bar with
        // its message. Opening the card without a code rendered a grey "Avisa a tu supervisor"
        // with no area, no colour and no retry button.
        // The polled payload has the same shape as the synchronous error body, so it goes
        // through the same resolver: a translated packing gate or legacy code reads the same
        // whichever way the error arrived.
        if (!result.error?.fulfillment_error_code) {
          setErrorMessage(
            resolveGenerateLabelErrorMessage({ response: { data: result.error } }, key => i18n.t(key)) || i18n.t('generate_shipment.label_pending.expired'),
          )
          return
        }
        setErrorMessage(null)
        setFulfillmentError({
          code: result.error.fulfillment_error_code,
          category: result.error.fulfillment_error_category,
          responsibleArea: result.error.fulfillment_error_responsible_area,
          flagType: result.error.fulfillment_error_flag_type,
          message: result.error.error || result.error.message,
          summary: result.error.fulfillment_error_summary,
          detail: result.error.fulfillment_error_detail,
          retryAfterSeconds: result.error.fulfillment_error_retry_after_seconds,
          nextCheckAt: result.error.fulfillment_error_next_check_at,
          retryCount: result.error.fulfillment_error_retry_count,
          maxRetries: result.error.fulfillment_error_max_retries,
        })
        return
      }

      if (result.unknown) {
        // Nothing left to poll and no label to show. Point the operator back at the
        // button rather than leaving the screen spinning forever.
        setLabelPending(null)
        setLoading(false)
        setErrorMessage(i18n.t('generate_shipment.label_pending.expired'))
      }
    }

    const timer = setInterval(check, LABEL_PENDING_POLL_MS)
    return () => {
      cancelled = true
      clearInterval(timer)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [labelPending, id])

  const onConfirmGenerateLabelHandler = async () => {
    setConfirmLoading(true)
    try {
      const response = await generateLabel(
        shipment,
        shippingAddress,
        effectiveShippingDetails,
        trackingNumberCorreios,
        isProductionEnvironment ? cameraSnapshot : null,
      )

      // 202: the carrier accepted the shipment and the label already exists — only its PDF
      // is still downloading. Hold the screen on a wait that clears itself instead of
      // showing an error the operator would answer by clicking generate again.
      if (response?.pending) {
        setLabelPending({
          transactionKey: response.transactionKey,
          estimatedSeconds: response.estimatedSeconds,
          waitReason: response.waitReason,
          startedAt: Date.now(),
        })
        setErrorMessage(null)
        setOpenConfirmDialog(false)
        setConfirmLoading(false)
        setOpenDialogCorreios(false)
        // The Ctrl+G shortcut raises the full-panel Loader before calling this handler. Left up,
        // it covers the wait banner for the whole wait, so the operator sees a frozen screen
        // instead of the guide being prepared.
        setLoading(false)
        return
      }

      await completeGenerateLabel(response)
    } catch (e) {
      const responseData = e?.response?.data
      if (e?.response?.status === 422 && responseData?.code === CAMERA_ERROR_CODES.CAMERA_REQUIRED) {
        setCameraBlockedMessage(responseData.message || null)
        setErrorMessage(null)
        setOpenConfirmDialog(false)
        setConfirmLoading(false)
        setLoading(false)
        setOpenDialogCorreios(false)
        return
      }
      // Defense in depth (§8.6): the strict server gate fired even though the
      // local UI check passed (e.g. a stale cache). Show a blocking dialog and
      // refresh the order so the audit block re-renders.
      if (e?.response?.status === 422 && responseData?.code === PACKING_AUDIT_REQUIRED_CODE) {
        setPackingAuditBlocked(true)
        setErrorMessage(null)
        setOpenConfirmDialog(false)
        setConfirmLoading(false)
        setLoading(false)
        setOpenDialogCorreios(false)
        return
      }
      // Operator-reported race (CUBBO-2149): a slow successful generate ships
      // the order while a second click is still in flight; the late click then
      // fails with ORDER_NOT_AUTHORIZED even though the operator only needs the
      // label that was just emitted. Re-check the order — if it already shipped,
      // refresh the page data (the emitted-labels section renders for shipped
      // orders) and show a print hint instead of a permissions error.
      if (e?.response?.status === 422 && responseData?.code === 'ORDER_NOT_AUTHORIZED') {
        try {
          const refreshedOrder = await fetchOrder(id)
          if (['shipped', 'returned', 'returning'].includes(refreshedOrder?.status)) {
            dispatch(setShipmentData({ ...shipment, status: refreshedOrder.status }))
            queryClient.invalidateQueries(`order-${id}`)
            setErrorMessage(i18n.t('generate_shipment.order_shipped_print_below'))
            setOpenConfirmDialog(false)
            setConfirmLoading(false)
            setLoading(false)
            setOpenDialogCorreios(false)
            return
          }
        } catch (refreshError) {
          // can't confirm the order state — fall through to the generic error
        }
      }
      // The backend classifies packing failures into a FulfillmentError (code,
      // category, responsible area). When it sends that classification, show the
      // structured operator card instead of a bare message line: it names who
      // resolves the error and what to do next. Anything unclassified keeps the
      // inline message path below.
      if (responseData?.fulfillment_error_code) {
        setFulfillmentError({
          code: responseData.fulfillment_error_code,
          category: responseData.fulfillment_error_category,
          responsibleArea: responseData.fulfillment_error_responsible_area,
          flagType: responseData.fulfillment_error_flag_type,
          message: responseData.error || responseData.message,
          summary: responseData.fulfillment_error_summary,
          detail: responseData.fulfillment_error_detail,
          retryAfterSeconds: responseData.fulfillment_error_retry_after_seconds,
          nextCheckAt: responseData.fulfillment_error_next_check_at,
          retryCount: responseData.fulfillment_error_retry_count,
          maxRetries: responseData.fulfillment_error_max_retries,
        })
        setErrorMessage(null)
      } else {
        setErrorMessage(resolveGenerateLabelErrorMessage(e, key => i18n.t(key)))
      }
      setOpenConfirmDialog(false)
      setConfirmLoading(false)
      setLoading(false)
      setOpenDialogCorreios(false)
    }
  }

  const handlePackingAuditBlockedAcknowledge = () => {
    setPackingAuditBlocked(false)
    queryClient.invalidateQueries(`order-${id}`)
  }

  // CUBBO-2182: SIP dead-end fix. When the current order can't advance within its
  // SKU (404 from the sibling-by-product lookup) or after it's sent to review, keep
  // the tote context and route the operator to the tote's product-scan view with the
  // tote pre-loaded (?tote=<unique_code>), instead of `no_more_orders` / going back.
  // They scan the next physical product and continue with the other orders in the
  // same tote — product verification stays intact (no silent different-SKU handoff).
  // Returns true when it navigated (SIP order with a known tote) so callers can fall
  // back to their previous behavior for non-SIP / no-tote orders.
  const goToToteProductScan = () => {
    const toteUniqueCode = data?.picking_order?.tote?.unique_code
    if (!data?.picking_order?.single_item_picking || !toteUniqueCode) {
      return false
    }
    dispatch(stopRecording())
    const search = new URLSearchParams({ tote: toteUniqueCode }).toString()
    history.push({
      pathname: GENERATE_LABELS.replace(':warehouse_id', warehouse_id),
      search: `?${search}`,
    })
    return true
  }

  const goToNextOrderInTote = async () => {
    setConfirmLoading(true)
    try {
      setLoadingButtonLoader(true)
      const new_excluded_picking_order_ids = inhereted_exclude_picking_order_ids.concat(data.picking_order.id)
      const pickingOrder = await fetchSipSiblingByProduct(
        data.picking_order.id,
        resolveSipProductIdentifier(resolveSipOrderLine(data.order_lines)),
        new_excluded_picking_order_ids,
      )

      const reviewBlock = getReviewBlockMessage(pickingOrder)
      if (reviewBlock) {
        setErrorMessage(i18n.t(reviewBlock.key, reviewBlock.params))
        setOpenConfirmDialog(false)
        setConfirmLoading(false)
        setLoadingButtonLoader(false)
        return
      }

      dispatch(stopRecording())

      const query = new URLSearchParams({ exclude_picking_order_ids: new_excluded_picking_order_ids })
      const exclude_picking_order_ids = decodeURIComponent(query)
      history.push({
        pathname: GENERATE_ORDER_LABEL.replace(':id', pickingOrder.order.id).replace(':warehouse_id', warehouse_id),
        search: `?${exclude_picking_order_ids}`,
      })
      // goToGenerateLabel(pickingOrder.order.id)
      setLoadingButtonLoader(false)
    } catch (e) {
      if (e.response && e.response.status === 404) {
        // No more orders for this SKU in the tote, but other SKUs may still
        // be pending. Route to the tote's product-scan view (tote pre-loaded)
        // so the operator can continue; only dead-end if we can't (non-SIP /
        // no tote), preserving the previous alert as a fallback.
        if (goToToteProductScan()) {
          return
        }
        window.alert(i18n.t('generate_shipment.no_more_orders'))
      }
      setErrorMessage(resolveGenerateLabelErrorMessage(e, key => i18n.t(key)))
      setOpenConfirmDialog(false)
      setConfirmLoading(false)
      setLoading(false)
      setOpenDialogCorreios(false)
    }
  }

  const handleClosePreview = () => {
    setTimeout(() => {
      // CUBBO-2182: on the SIP happy path (label generated), return to the tote
      // pre-loaded (+ pending list) so the operator keeps packing the same tote
      // without re-scanning it — matching the failure/review paths. Falls back to
      // the blank module for non-SIP / no-tote orders.
      if (!goToToteProductScan()) {
        history.push(GENERATE_LABELS.replace(':warehouse_id', warehouse_id))
      }
    }, 500)
  }

  const handleCarreiosSubmit = function (tracking_number) {
    setTrackingNumber(tracking_number)
    //if(hotkey) onConfirmGenerateLabelHandler()
    //else
    setOpenConfirmDialog(true)
  }

  const handleImeiSubmit = function (imei) {
    const allScannedImeis = shipment.productsData.map(productData => productData.imeis).flat()
    const imeiIsDuplicate = allScannedImeis.includes(imei)

    if (imeiIsDuplicate) {
      setAlert(i18n.t('generate_shipment.imei_duplicate'))
      setOpenDialogImei(false)
      return false
    }

    const newProductsData = cloneDeep(shipment.productsData)
    const alreadyScannedProductIndex = newProductsData.findIndex(productData => productData.product_id === reviewedProductId)
    if (alreadyScannedProductIndex === -1) {
      newProductsData.push({
        product_id: reviewedProductId,
        imeis: [imei],
      })
    } else {
      newProductsData[alreadyScannedProductIndex].imeis.push(imei)
    }

    dispatch(
      setShipmentData({
        ...shipment,
        productsData: newProductsData,
      }),
    )

    // For has_imei products the backend wants the original product code
    // as `code` and the captured serial as `imei` (separate parameters).
    // Sending the IMEI as `code` would 422 with `imei_required`.
    increaseReviewedItemsCount(reviewedProductId, reviewedProductCode, imei)
    setOpenDialogImei(false)
  }

  // ── Packing sessions ─────────────────────────────────────────────
  // Two-step lifecycle:
  //   1) On order load, PEEK for an existing open session via GET
  //      /packing-sessions?order_id=… and attach if found (regardless of
  //      packages_count). This lets us pick up progress from a prior
  //      visit even if the operator hasn't bumped Paquetes yet.
  //   2) Only CREATE a new session when none exists AND either (a) the
  //      operator is a beta tester (we use the session for every order in
  //      that flow) or (b) they're in legacy multi-box mode (packages_count
  //      >= 2). Single-box legacy orders keep the legacy reviewedItemsCount-
  //      only flow without a session.
  // The multi-box packing session flow is enabled for:
  //   1. Beta testers (any order), for the staged rollout.
  //   2. B2B and REM orders (any operator), because those workflows always
  //      need multi-box tracking regardless of the operator's role.
  // Every other case (non-beta operator on a plain D2C order) keeps the
  // legacy local-only flow: no PackingSession is created on the backend,
  // so we never leak an OPEN session that the legacy footer won't /conclude.
  //
  // A "REM" order is any stock-removal type — REMOVE_STOCK,
  // REMOVE_DAMAGED_STOCK, REMOVE_EXPIRED_STOCK, REMOVE_LOST_STOCK — all of
  // which share the `REMOVE_` prefix. We match on order_type + is_b2b only
  // (no order_number regex / pickup heuristics) to avoid false positives
  // that would attach a real backend session to a plain D2C order.
  const isB2bOrRemOrder = order => {
    if (!order) return false
    if (order.is_b2b) return true
    return typeof order.order_type === 'string' && order.order_type.startsWith('REMOVE_')
  }
  const willUseMultiBox = isBetaTesterUser(user) || isB2bOrRemOrder(data)

  // Step 1: peek
  // Don't gate on data.status — orders enter GenerateShipment in 'processing'
  // (post-pick, pre-pack) as well as 'packing', and we want to surface any
  // existing session regardless of where the operator picked up. The backend
  // is authoritative; a 404 / wrong-status here just marks lookup done.
  useEffect(() => {
    if (!data?.id || sessionLookupDone) return
    // Only orders/operators eligible for the multi-box flow (beta testers,
    // or any B2B/REM order) participate in the session lifecycle. Skip the
    // peek otherwise so a pre-existing orphan session (from a previous code
    // version that created sessions for non-beta multi-paquete) doesn't
    // attach and trigger /packing-sessions polling + address lock for
    // operators on the legacy flow.
    if (!willUseMultiBox) {
      setSessionLookupDone(true)
      return
    }
    // Terminal orders (shipped/cancelled) still peek — but read-only.
    // We attach to the session that produced the shipment so the packed
    // counts + already-generated cajas/documents restore (CUBBO-2440),
    // WITHOUT reopening the packing cycle (the create effect below stays a
    // no-op, polling is cut, and we skip setAttachedToExistingSession so the
    // ShippingPackageDataSection restore + Redux dispatch never fire).
    const terminal = isTerminalOrderStatus(data.status)
    let cancelled = false
    listPackingSessionsForOrder(data.id)
      .then(sessions => {
        if (cancelled) return
        // PackingSession.status is upper-cased on the wire ("OPEN"/"CLOSED").
        // PackingBox.status stays lowercase ("open"/"processing"/"closed").
        // Active → the OPEN session; terminal → the latest session that
        // produced the shipment (see pickSessionForDisplay).
        const session = pickSessionForDisplay(sessions, data.status)
        if (session) {
          queryClient.setQueryData(['packingSession', session.id], session)
          setPackingSessionId(session.id)
          if (!terminal) setAttachedToExistingSession(true)
        }
        setSessionLookupDone(true)
      })
      .catch(() => {
        if (!cancelled) setSessionLookupDone(true)
      })
    return () => {
      cancelled = true
    }
    // `user` and the order's B2B/REM type are both captured by `willUseMultiBox`.
  }, [data?.id, data?.status, sessionLookupDone, willUseMultiBox])

  // Step 2: create only if needed (no existing session AND multi-box).
  // Same status policy as the peek — backend gates whether the order is
  // pack-ready, frontend just initiates when we have a beta tester or
  // legacy multi-paquete order.
  useEffect(() => {
    if (!data?.id || packingSessionId) return
    // Never CREATE a session for a terminal order — the peek already
    // attached the shipment's session read-only (CUBBO-2440).
    if (isTerminalOrderStatus(data.status)) return
    if (!sessionLookupDone) return
    if (!willUseMultiBox) return
    let cancelled = false
    startPackingSession(data.id)
      .then(session => {
        if (cancelled) return
        setSessionStartBlockedCode(null)
        queryClient.setQueryData(['packingSession', session.id], session)
        setPackingSessionId(session.id)
      })
      .catch(err => {
        if (cancelled) return
        const code = err?.response?.data?.code
        // Remember WHY there is no session: addProducts refuses to count scans
        // while this is set. Before, a "benign" failure (order not in packing
        // yet) was swallowed whole and the operator could scan an entire caja
        // that only lived in the local counter and the pending queue — which
        // then drained as one burst of parallel POSTs once a box finally opened.
        setSessionStartBlockedCode(code || 'unknown')
        // Codes that mean "no session yet, retry later via the
        // lifecycle effects" → no red bar (the scan-time alert covers
        // them). Everything else surfaces in the red bar so the operator
        // isn't left guessing why scans aren't landing.
        if (!BENIGN_SESSION_START_CODES.includes(code)) {
          setErrorMessage(err?.response?.data?.error || err.message || i18n.t('generate_shipment.multi_box.could_not_start_session'))
        }
      })
    return () => {
      cancelled = true
    }
  }, [data?.id, data?.status, packingSessionId, willUseMultiBox, sessionLookupDone])

  // Self-healing for a BENIGN session-start block: keep re-fetching the order
  // until its status lets the start effect (above — it keys on data?.status)
  // retry and clear the block. Without this the only thing that ever refreshed
  // the order was refetchOnWindowFocus, so an operator who scanned early got
  // the "not ready" alert for the life of the page — in the flow whose whole
  // point is that they stop reloading it.
  useEffect(() => {
    if (!sessionStartBlockedCode || packingSessionId) return undefined
    if (!BENIGN_SESSION_START_CODES.includes(sessionStartBlockedCode)) return undefined
    const timer = setInterval(() => queryClient.invalidateQueries(`order-${id}`), SESSION_START_RETRY_POLL_MS)
    return () => clearInterval(timer)
  }, [sessionStartBlockedCode, packingSessionId, id, queryClient])

  const { data: packingSession } = useQuery(['packingSession', packingSessionId], () => getPackingSession(packingSessionId), {
    enabled: !!packingSessionId,
    // Multi-operator sync per backend handoff (CUBBO-2067). Stop the
    // interval once the session is closed — nothing more will change —
    // and never poll a terminal order's read-only session (CUBBO-2440).
    // refetchIntervalInBackground defaults to false, so we also pause
    // automatically when the tab isn't focused.
    // Fast poll only while ANOTHER station is actively packing too:
    // participants is everyone who EVER joined, so raw length would pin the
    // 3s poll forever after any user handoff (countActiveParticipants).
    refetchInterval: sess => shouldPollPackingSession(data?.status, sess?.status, countActiveParticipants(sess?.participants)),
    refetchOnWindowFocus: false,
  })

  // The redesigned MultiBoxPackingPanel renders whenever the multi-box flow
  // is enabled for this operator + order (beta testers on any order, plus any
  // B2B/REM order). The legacy ShippingPackageDataSection +
  // RecommendedPackageSection only show for the remaining non-beta D2C case.
  // Adding more paquetes happens via "Añadir otra caja" inside the new panel,
  // not via the legacy +/- counter.
  const useNewPackingUI = willUseMultiBox

  // "The order query has RESOLVED" — the precondition both packing effects
  // below need before they can trust the junk-caja rule, which is derived from
  // the order's lines. A boolean, and deliberately NOT `data?.order_lines`:
  // that array gets a fresh identity on every 3s refetch, so depending on it
  // re-ran both effects on every poll for nothing.
  const orderLoaded = !!data

  // BUGS-7317: some orders (notably removals — REMOVE_* — of injertos/inserts)
  // contain ONLY non-scannable products (product.is_scannable === false).
  // There is nothing to bipar, so the multi-box "scan at least 1 piece" gate
  // can never be met and the box can't be closed → the order can't be
  // finalized. Detect that case (mirrors the productsToReviewById split in
  // setOrderData) so the panel lets the operator close the box without a scan.
  const hasNoScannableItems = useMemo(() => {
    const lines = data?.order_lines || []
    if (!lines.length) return false
    const anyScannable = lines.some(line => {
      if (!line.product?.is_scannable) return false
      if (line.product?.is_kit && line.product?.kit_childs?.length) {
        return line.product.kit_childs.some(kc => !kc.child_product?.is_dropshipping && kc.child_product?.is_scannable)
      }
      return true
    })
    return !anyScannable
  }, [data?.order_lines])

  // CUBBO-2440: terminal orders (shipped/cancelled) restore the packed cajas +
  // documents for reference only. Everything that would mutate the session —
  // the scan input, the panel's reopen/close/delete/add-caja, and the footer —
  // is gated off so the operator isn't invited into a flow the backend rejects.
  const packingReadOnly = isTerminalOrderStatus(data?.status)

  // The empaques that travel to the carrier, read from the session's boxes instead
  // of the Redux copy, which never follows an empaque change. Null keeps the
  // previous behavior: no session, no live boxes, or an empaque missing from the
  // catalog.
  const derivedLabelPackages = useMemo(() => {
    // A terminal order's session is attached for reference only. The read-only
    // state is now an explicit gate on both label-emission entry points (the
    // footer's isSaveDisabled and the ctrl+g shortcut share labelEmissionBlocked),
    // so nothing here can re-conclude a shipped order — but the derived packages
    // stay null so a reference-only view never feeds the carrier payload.
    if (packingReadOnly) return null
    // An unresolved slot — no empaque picked, or the restore effect could not
    // resolve one — keeps the old behavior instead of guessing.
    if ((shippingDetails?.packages || []).some(shippingPackage => !shippingPackage)) return null
    return buildLabelPackages(packingSession, shippingPackages?.data, shippingDetails?.packages, hasNoScannableItems)
  }, [packingReadOnly, shippingDetails?.packages, packingSession, shippingPackages?.data, hasNoScannableItems])

  const effectiveShippingDetails = useMemo(() => withDerivedPackages(shippingDetails, derivedLabelPackages), [shippingDetails, derivedLabelPackages])

  // Map backend session boxes → component shape (items keyed by SKU with qty).
  // Backend can return `sku: null` for packed_units resolved via UPC/bar_code
  // (the alternative-code branch of /scan). Resolve via the order_line's
  // product so the operator still sees the canonical SKU and name.
  const packedUnitKey = u => {
    if (u.sku) return u.sku
    // Look up the order_line → product → product_codes to recover the SKU.
    if (u.order_line_id && data?.order_lines) {
      const orderLine = data.order_lines.find(ol => ol.id === u.order_line_id)
      const productSku = orderLine?.product?.product_codes?.find(pc => pc.sku)?.sku
      if (productSku) return productSku
    }
    // Penultimate: any alternate code the backend echoed back.
    if (u.product_code) return u.product_code
    if (u.upc) return u.upc
    if (u.bar_code) return u.bar_code
    // Last resort: a stable per-stock-unit synthetic key so the row at
    // least renders. Description-fallback in productNameBySku still
    // gives a human label.
    return `unit-${u.stock_unit_id ?? u.id}`
  }
  // Resolve a packed_unit to the correct product.id key inside productsToReviewById.
  // Handles kits (order_line.product is the KIT PARENT, while the dict is keyed by
  // kit_child.product.id) and units resolved via UPC/bar_code (sku=null on the unit).
  // The ladder itself lives in unitProductResolution.js so it can be covered: this
  // screen has no component harness, and a kit child that fails to resolve is now a
  // dead end rather than a cosmetic count (BUGS-8257).
  const resolveUnitProductId = u => resolveUnitProductIdFor({ unit: u, productsToReviewById, orderLines: data?.order_lines })
  const sessionBoxes = (packingSession?.packing_boxes || [])
    .map(b => {
      // Merge any in-flight optimistic placeholders for this box (kept in
      // a separate state so polling refetches don't wipe them — that was
      // the root cause of the "first scan appears → disappears → reappears"
      // flicker). The merged list is what feeds box.items and the
      // boxesBreakdown pills downstream.
      const optimisticForBox = optimisticUnitsByBoxId[b.id] || []
      const mergedUnits = [...(b.packed_units || []), ...optimisticForBox]
      const items = {}
      const itemsInFlight = {}
      for (const u of mergedUnits) {
        const key = packedUnitKey(u)
        items[key] = (items[key] || 0) + 1
        if (u._optimistic) {
          itemsInFlight[key] = (itemsInFlight[key] || 0) + 1
        }
      }
      return {
        id: b.id,
        box_number: b.box_number,
        position: b.position,
        items,
        itemsInFlight,
        is_closed: b.status === 'closed',
        closed_at: b.closed_at,
        shipping_package_id: b.shipping_package_id,
        // Document URLs surfaced after close — PaqueteCard's three print
        // buttons (packing list / etiqueta / NF-e) only render when their
        // respective URL is present on the box.
        packing_list_url: b.packing_list_url,
        shipping_label_url: b.shipping_label_url,
        invoice_url: b.invoice_url,
        carrier_supports_per_box_label: b.carrier_supports_per_box_label,
        // Include in-flight optimistic placeholders so downstream
        // consumers (PaqueteCard items list, boxesBreakdown pills) see
        // the same merged view.
        packed_units: mergedUnits,
      }
    })
    // Drop DISCARDED boxes (closed with no products) — clean-up artifacts left
    // behind when an empty box is closed/auto-closed. Excluding them HERE, at the
    // single source, keeps every downstream index COMPACT so they all agree:
    // the panel cards, the handlers (sessionBoxes[idx]), the "Paquete N"
    // numbering AND the lazy-open's next-slot position (a compacted live-box
    // count). Leaving holes in this array meant a virtual slot landed at an index
    // the lazy-open didn't recognise, so the next box never opened, close/delete
    // targeted the wrong box, and the "Paquete N" numbers drifted (BUGS-7438
    // follow-up). NOTE: this is exactly the same set the lazy-open effect calls
    // "live boxes", so sessionBoxes.length lines up with its live-box count.
    // What counts as junk lives in ONE place (isJunkBox) because every derived
    // index here has to skip the exact same set — including its exception for
    // orders with nothing scannable, where a sealed caja IS legitimately empty.
    .filter(b => !isJunkBox(b, hasNoScannableItems))

  // Multi-box orders only emit once every box is sealed. Shared by the footer and the
  // ctrl+g shortcut, which used to skip this gate entirely (BUGS-8257).
  const multiBoxAwaitingClosedBoxes = useNewPackingUI && !(sessionBoxes.length > 0 && sessionBoxes.every(b => b.is_closed))

  // Placeholders are dropped by the scan's own settlement (persistScanToBox:
  // a 200 — packed or replayed — drops it with the real unit in hand; a final
  // failure rolls it back). No poll-driven count reconcile: every enqueued
  // attempt settles within the request timeout × 2 (one same-key replay), so
  // there is nothing left for the poll to adjudicate — and count thresholds
  // were exactly what confirmed scans that never landed (stale snapshots
  // shared across a burst).

  const activeBoxIdx = Math.max(
    0,
    sessionBoxes.findIndex(b => b.id === activeBoxId),
  )

  // ── Single source of truth for the operator-facing "Paquete N" number ──
  // A paquete's number is its 1-based position among the boxes the operator
  // ACTUALLY sees. Discarded boxes (closed with no products — clean-up left
  // behind after emptying or auto-closing an empty box) are hidden from the
  // panel, so they must NOT consume a number; otherwise "Estás empacando en
  // Paquete N" and the distribution pills drift ahead of the cards
  // (BUGS-7438 follow-up: the header said "Paquete 3" while the active card
  // was "PAQUETE 2"). We key on the stable box `id` — never the array index
  // (shifts as boxes close/delete) nor box_number (backend-monotonic, e.g.
  // 7/8/9, never resets to 1). The panel numbers its cards with the exact same
  // rule (skip junk cajas, 1..N in order), so the two always agree — both go
  // through isJunkBox, exception included.
  const isBoxDiscarded = b => isJunkBox(b, hasNoScannableItems)
  const paqueteNumberByBoxId = (() => {
    const map = {}
    let n = 0
    for (const b of sessionBoxes) {
      if (isBoxDiscarded(b)) continue
      map[b.id] = ++n
    }
    return map
  })()

  // Locks paquetería + dirección once a label is committed to the carrier
  // in a way the operator can't easily reverse from the UI.
  //
  // - Scenario A (carrier_supports_per_box_label=true, e.g. Cubbo / DHL):
  //   each /close mints a real carrier label tied to that exact destination,
  //   and the operator would need /regenerate-label per box to re-sync.
  //   Lock as soon as ANY box has a shipping_label_url.
  // - Scenario B (Natura / Estafeta / Blue Express / etc.): labels are
  //   produced in bulk by the legacy generate-labels endpoint, which the
  //   operator can invalidate and re-call with new address/method. DO NOT
  //   lock just because data.shipping_labels has entries.
  // - EXCEPTION: when the order is already shipped (alreadyHasLabels), the
  //   footer is in "Invalidar etiquetas anteriores" mode — the operator IS
  //   about to invalidate + re-mint with current paquetería + dirección, so
  //   we leave both editable regardless of scenario.
  const carrierMintsPerBox = (shippingDetails?.shippingMethod || data?.shipping_method)?.carrier_supports_per_box_label === true
  // Cross-check observed labels: if any closed box already has a
  // shipping_label_url we treat the order as Scenario A regardless of
  // whether the shipping_method's flag is explicitly set. Same cross-check as
  // `isPerBoxLabelScenario` twelve lines below (:1482) — the one derivation the
  // footer's routing, its button label and the ctrl+g refusal all read — so the
  // address/paquetería lock can't drift open when labels exist but the flag is
  // missing on a record.
  const observedPerBoxLabels = sessionBoxes.some(b => b.shipping_label_url)
  const shippingLabelsAlreadyMinted = !alreadyHasLabels && (carrierMintsPerBox || observedPerBoxLabels) && observedPerBoxLabels

  // Scenario A: every /close already minted this box's carrier label, so the footer's
  // primary button FINALIZES the order (POST /conclude) instead of asking for the bulk
  // guides. Derived once, here, because three call sites used to rebuild it from the
  // same two inputs — the footer's onSave routing, the footer's button label, and the
  // ctrl+g shortcut, which now refuses in this state. Same reason the emission gate
  // lives in packingGates: a second copy of a rule is how the shortcut drifted away
  // from the footer (BUGS-8257). The observed-labels cross-check keeps a
  // shipping_method whose flag is missing on the record from being read as scenario B
  // once its closes have minted per-box labels.
  const isPerBoxLabelScenario = useNewPackingUI && (carrierMintsPerBox || observedPerBoxLabels)

  // One-shot snapshot: restore ShippingPackageDataSection state from the
  // backend session's boxes (shipping_package_id per box). Runs ONCE when
  // all dependencies are loaded — packageDataKey then forces a remount of
  // ShippingPackageDataSection with the restored packages as initial props.
  useEffect(() => {
    if (restoredPackagesSnapshot) return
    // Only restore when we ATTACHED to a session that already had progress.
    // Newly created sessions (from a fresh POST) start with packing_boxes=[]
    // and would otherwise trigger this effect mid-bootstrap once the first
    // box-open POST patches the cache, dispatching packages_count=1 and
    // tripping the decrement effect into closing everything.
    if (!attachedToExistingSession) return
    if (!packingSession?.packing_boxes?.length) return
    if (!shippingPackages?.data) return
    // The junk-caja rule below hinges on whether the order has anything
    // scannable, which is only knowable once its lines are loaded. This
    // effect is ONE-SHOT, so restoring from a half-loaded order would
    // snapshot the wrong package list and never correct itself.
    // Gate on the QUERY being resolved, not on the lines being non-empty:
    // `data` is one payload from one useQuery (no keepPreviousData), so it is
    // either undefined or the whole order — lines included. Testing
    // `order_lines.length` instead would ALSO bail on an order that resolved
    // with zero lines, and since this effect is one-shot it would never run
    // again: no packages restored, nothing surfaced to the operator. The
    // `orderLoaded` dependency below still re-runs this when the order lands.
    if (!orderLoaded) return
    // Only restore from LIVE cajas. A junk caja would otherwise add a phantom
    // slot to shippingDetails.packages, pinning the Paquetes UI to a stuck
    // count — while on an order with nothing scannable the inverse bites:
    // dropping the real (empty) cajas restored NO packages at all, so the
    // footer's package validation could never pass.
    const liveBoxes = packingSession.packing_boxes.filter(b => !isJunkBox(b, hasNoScannableItems))
    if (!liveBoxes.length) return
    const packages = liveBoxes.map(b => {
      const pkgId = b.shipping_package_id ?? b.shipping_package?.id ?? null
      return pkgId ? shippingPackages.data.find(p => p.id === pkgId) || null : null
    })
    setRestoredPackagesSnapshot({
      sessionId: packingSession.id,
      packages,
    })
    // Also push to Redux so the MultiBoxPackingPanel and footer validation
    // see the restored package selection. Read the latest shippingDetails
    // via the ref — using the closure value would overwrite any edits the
    // operator made between attach-detection and this effect firing.
    dispatch(
      setShippingDetails({
        ...shippingDetailsRef.current,
        packages,
        packages_count: packages.length,
      }),
    )
  }, [attachedToExistingSession, packingSession, shippingPackages, restoredPackagesSnapshot, orderLoaded, hasNoScannableItems])

  // One-shot: bring ProductListSection's reviewedItemsCount in sync with
  // packed_units already in the session, so previously-packed items show
  // as completed in the "Productos requeridos" list when the operator
  // re-enters the page.
  useEffect(() => {
    if (!packingSession?.packing_boxes?.length) return
    if (!Object.keys(productsToReviewById).length) return
    // NOT one-shot on purpose. The old guard (productsRestoredFromSession)
    // ran this exactly once — whatever packed_units the very first
    // packingSession render carried became the frozen reviewedItemsCount.
    // If the polling refetch (every 3s) later brought MORE packed_units
    // (multi-operator, backend catch-up, etc.), the local counter never
    // caught up and the operator saw "6 pendientes de revisar" while the
    // caja already held all 16 pieces → next scan hit backend and got
    // "Esta unidad o todas sus piezas ya están empacadas".
    //
    // Safe to re-run because the merge below ONLY increases the local
    // count (`current < count`). Optimistic local bumps that haven't
    // reached the server yet stay put.
    const packedByProductId = {}
    for (const box of packingSession.packing_boxes) {
      for (const u of box.packed_units || []) {
        if (u._optimistic || u._synthetic) continue
        const productId = resolveUnitProductId(u)
        if (productId) {
          packedByProductId[productId] = (packedByProductId[productId] || 0) + 1
        }
      }
    }
    const updated = { ...productsToReviewById }
    let changed = false
    Object.entries(packedByProductId).forEach(([productId, count]) => {
      const current = updated[productId]?.reviewedItemsCount || 0
      if (updated[productId] && current < count) {
        updated[productId] = { ...updated[productId], reviewedItemsCount: count }
        changed = true
      }
    })
    if (changed) setProductsToReviewById(updated)
    if (!productsRestoredFromSession) setProductsRestoredFromSession(true)
  }, [packingSession, productsToReviewById, productsRestoredFromSession, data])

  // Keep the active caja meaningful as the session's boxes change: adopt the
  // caja the operator just opened as soon as it shows up, otherwise keep the
  // current one while it is open, otherwise the first open one (or none).
  // Switching cajas is also what hands the focus back to the scan input.
  useEffect(() => {
    if (!sessionBoxes.length) return
    const preferredBoxId = pendingActiveBoxIdRef.current
    if (preferredBoxId != null && sessionBoxes.some(b => b.id === preferredBoxId)) {
      pendingActiveBoxIdRef.current = null
    }
    const next = resolveActiveBoxId({ boxes: sessionBoxes, activeBoxId, preferredBoxId })
    if (next !== activeBoxId) setActiveBoxId(next)
  }, [sessionBoxes, activeBoxId])

  // Hand the keyboard focus to the scan input whenever the multi-box flow
  // reaches "the next thing to do is scan": the active caja is open and has
  // its empaque, and no dialog is up. Re-runs on caja open (activeBoxId), on
  // empaque change (activeBoxPackageId), when the post-close packing-list
  // preview or any other dialog closes, and on an explicit nudge
  // (requestScanFocus) for the paths that change nothing observable.
  // The barcode scanner is a keyboard — it types into whatever has the focus.
  // Before this, picking the empaque left the focus in the Headless UI
  // combobox (it re-focuses its own input on the next frame), the scan typed
  // into the empaque filter, and the operator refreshed the page to recover.
  // Only primitives in the deps: the active box object is re-derived every
  // render and would re-fire this on every poll, stealing the focus from
  // whatever the operator is typing into.
  const activeBoxForFocus = sessionBoxes.find(b => b.id === activeBoxId) || null
  const activeBoxPackageId = activeBoxForFocus?.shipping_package_id ?? null
  const activeBoxIsClosed = !!activeBoxForFocus?.is_closed
  const anyDialogOpen = !!(hasBlockingOverlay || packingAuditBlocked || lastBoxCloseConfirm)
  useEffect(() => {
    const activeBox = activeBoxId ? { id: activeBoxId, is_closed: activeBoxIsClosed, shipping_package_id: activeBoxPackageId } : null
    if (!shouldFocusScanInput({ multiBox: useNewPackingUI, readOnly: packingReadOnly, activeBox, dialogOpen: anyDialogOpen })) return
    const timer = setTimeout(() => inputRef.current?.focus(), SCAN_INPUT_FOCUS_DELAY_MS)
    return () => clearTimeout(timer)
  }, [useNewPackingUI, packingReadOnly, activeBoxId, activeBoxPackageId, activeBoxIsClosed, anyDialogOpen, scanFocusNonce])

  // Reconcile the "caja activa" against the server when the operator changes
  // mid-session (shared packing station, "cambiar de usuario" without a full
  // page reload). The whole page stays mounted across the handoff, so
  // `activeBoxId` and the react-query cache still reflect the PREVIOUS
  // operator's box — which may already be closed or deleted on the server.
  // Every scan/close/delete then targets that stale box and the backend
  // rejects it (:box_not_open / :box_closed), surfaced as "La caja activa está
  // cerrada — selecciona otra" even though the panel still shows the box open.
  //
  // The backend is authoritative (each op carries an explicit box_id; there is
  // no server-side "active box"), so the fix is purely FE reconciliation:
  //   1) drop the stale pointer now, so nothing fires against the old box
  //      before fresh data lands, and
  //   2) force an immediate refetch of the session (bypassing the CLOSED /
  //      terminal poll-stop guard) so the authoritative box statuses flow in
  //      and the auto-pick effect above repoints to a real open box.
  const prevUserIdRef = useRef(user?.id)
  useEffect(() => {
    const currentUserId = user?.id
    if (prevUserIdRef.current === currentUserId) return
    prevUserIdRef.current = currentUserId
    if (!packingSessionId) return
    setActiveBoxId(null)
    queryClient.invalidateQueries(['packingSession', packingSessionId])
  }, [user?.id, packingSessionId])

  // Drain pending scans (queued by persistScanToBox while session/box were
  // bootstrapping) as soon as both become available. Without this, the very
  // first scan after entering a multi-box order vanishes because the
  // legacy increment runs ahead of the session POST.
  useEffect(() => {
    if (!pendingScansRef.current.length && !pendingContainerScansRef.current.length) return
    if (!packingSessionId) return
    const cached = queryClient.getQueryData(['packingSession', packingSessionId])
    const hasOpenBox = (cached?.packing_boxes || []).some(b => b.status !== 'closed')
    if (!hasOpenBox) return
    const pending = [...pendingScansRef.current]
    pendingScansRef.current = []
    pending.forEach(({ code, imei, productId }) => persistScanToBox(code, imei, productId))
    drainPendingContainerScans()
  }, [packingSessionId, packingSession])

  // Bidirectional sync: Paquetes count decreases (operator clicks "-") →
  // close excess empty boxes on backend. If packages_count drops to 1, we
  // also close the session so the order goes back to the legacy flow.
  useEffect(() => {
    // CUBBO-2440: terminal orders attach their session read-only (packingSessionId
    // is now set for shipped/cancelled), so this write-effect must stay inert —
    // never close boxes / conclude a finalized order behind the operator's back.
    if (packingReadOnly) return
    const newLength = shippingDetails?.packages_count || 1
    const prevLength = prevPackagesLengthRef.current
    // First run: just record and exit. Establishes the baseline so the
    // next change shows a real delta.
    if (prevLength === null) {
      prevPackagesLengthRef.current = newLength
      return
    }
    if (newLength >= prevLength) {
      // Increase / equal — handled by the open-box effect. Record so the
      // next decrement compares against the actual previous length.
      prevPackagesLengthRef.current = newLength
      return
    }
    if (!packingSessionId || !packingSession?.packing_boxes?.length) {
      prevPackagesLengthRef.current = newLength
      return
    }
    // Don't update prevPackagesLengthRef yet when an in-flight close is
    // running — the second click was a real decrement we'd otherwise
    // lose. Bail without recording; the next render after the in-flight
    // close resolves will re-enter with the same baseline and process
    // the queued reduction.
    if (closingBoxesRef.current) return

    prevPackagesLengthRef.current = newLength
    closingBoxesRef.current = true

    ;(async () => {
      try {
        // Read FRESH session state from React Query at the moment we
        // act. The effect's closure can be one render behind a scan/
        // close that just patched the cache, and acting on stale
        // openBoxes would either skip a just-opened box or attempt
        // to close one another path already closed (422 in red bar).
        const cached = queryClient.getQueryData(['packingSession', packingSessionId])
        const allBoxes = cached?.packing_boxes || packingSession.packing_boxes
        const openBoxes = allBoxes.filter(b => b.status !== 'closed')
        if (newLength <= 1 && !willUseMultiBox) {
          // Legacy non-multi-box path: going back to single-box closes
          // everything and ends the session. Anyone eligible for the new
          // UI (beta testers OR B2B/REM orders) stays in it even at
          // 1 paquete — the session is the canonical flow for them.
          for (const b of openBoxes) {
            if ((b.packed_units || []).length > 0) {
              setAlert(i18n.t('generate_shipment.multi_box.cannot_close_session_with_items', { n: paqueteNumberByBoxId[b.id] || b.box_number }))
              return
            }
            await closePackingBox(b.id)
          }
          await closePackingSession(packingSessionId)
          queryClient.removeQueries(['packingSession', packingSessionId])
          setPackingSessionId(null)
          setActiveBoxId(null)
          setRestoredPackagesSnapshot(null)
          setProductsRestoredFromSession(false)
          boxOpenGuardRef.current.reset()
          // Reset the baseline so a later bump+drop on the same page
          // doesn't compare against this now-stale session's counter.
          prevPackagesLengthRef.current = null
          return
        }
        // Decrement but still multi-box → close the trailing empty open boxes.
        const excess = openBoxes.length - newLength
        if (excess <= 0) return
        const toClose = openBoxes.slice(-excess)
        for (const b of toClose) {
          if ((b.packed_units || []).length > 0) {
            setAlert(i18n.t('generate_shipment.multi_box.cannot_close_box_with_items', { n: paqueteNumberByBoxId[b.id] || b.box_number }))
            continue
          }
          const updated = await closePackingBox(b.id)
          queryClient.setQueryData(['packingSession', packingSessionId], old => {
            if (!old) return old
            return {
              ...old,
              packing_boxes: (old.packing_boxes || []).map(box => (box.id === updated.id ? { ...box, ...updated } : box)),
            }
          })
        }
      } catch (err) {
        setErrorMessage(err?.response?.data?.error || i18n.t('generate_shipment.multi_box.could_not_adjust_boxes'))
      } finally {
        closingBoxesRef.current = false
      }
    })()
    // `willUseMultiBox` is read at the single-box branch above; it's stable for
    // a given order so including it here won't cause extra runs.
  }, [shippingDetails?.packages_count, packingSessionId, packingReadOnly, willUseMultiBox])

  // Reset duplicate-open guard when session changes (close + re-open across packages_count flicker).
  useEffect(() => {
    boxOpenGuardRef.current.reset()
  }, [packingSessionId])

  // Open backend boxes lazily as the operator picks a shipping_package
  // for each position. We open one box at a time, in order, only when the
  // matching `shippingDetails.packages[i].id` is present — the backend
  // requires `shipping_package_id` for every box.
  // After each POST we make sure the box is in the cache so the next render
  // sees it without waiting for the 3s poll.
  useEffect(() => {
    // CUBBO-2440: never open a backend box on a terminal order — its session
    // is attached read-only, so this lazy-open lifecycle must stay inert even
    // though packingSessionId is now populated for shipped/cancelled orders.
    if (packingReadOnly) return
    if (!packingSessionId || !packingSession || openingBoxRef.current) return
    // Same dependency as the restore effect: the live-caja count below runs
    // through the junk-caja rule, so don't act on a half-loaded order. Same
    // reason it tests `data` and not `order_lines.length` — a zero-line order
    // would otherwise never open a caja, with nothing shown to the operator.
    if (!orderLoaded) return
    const positions = shippingDetails?.packages || []
    // Count only "live" cajas. Junk cajas are hidden from the operator's
    // view, so the next package selection should open a NEW caja at the next
    // position — not silently skip because a junk slot fills the raw count.
    // Same predicate as the panel and sessionBoxes, so the counts agree.
    const liveBoxes = (packingSession.packing_boxes || []).filter(b => !isJunkBox(b, hasNoScannableItems))
    // Claim the next slot that needs a backend box. The guard skips when no
    // empaque is picked for the slot yet, or an open for this exact slot is
    // already in flight (StrictMode double-invoke / fast dep changes). It is
    // released in `finally`, so a slot freed by a later close/delete can be
    // re-opened with the same empaque (CUBBO-2440 d) — a permanent history
    // used to silently skip that POST, leaving a phantom card.
    const claim = boxOpenGuardRef.current.claim(liveBoxes.length, positions)
    if (!claim) return
    openingBoxRef.current = true
    ;(async () => {
      let alreadyCached = false
      try {
        const newBox = await openPackingBox(packingSessionId, claim.shippingPackageId)
        // The operator just set this caja up — the next scans belong to it.
        // Adopted by the active-caja effect once the cache carries the box.
        pendingActiveBoxIdRef.current = newBox.id
        // Drop the in-flight GET so it can't undo this patch. Not silent: a
        // silent cancel leaves the query fetching forever and stops the poll.
        await queryClient.cancelQueries({ queryKey: ['packingSession', packingSessionId] }, { revert: false })
        queryClient.setQueryData(['packingSession', packingSessionId], old => {
          if (!old) return old
          // A poll may have brought this box already.
          if ((old.packing_boxes || []).some(b => b.id === newBox.id)) {
            alreadyCached = true
            return old
          }
          return { ...old, packing_boxes: [...(old.packing_boxes || []), newBox] }
        })
      } catch (err) {
        setErrorMessage(resolvePackingErrorMessage(err, SCAN_ERROR_MESSAGES, err?.message || i18n.t('generate_shipment.multi_box.could_not_open_box')))
      } finally {
        boxOpenGuardRef.current.release(claim.positionKey)
        openingBoxRef.current = false
        // Bump last: the re-run must see the refs already freed.
        if (alreadyCached) setBoxOpenSignal(n => n + 1)
      }
    })()
  }, [shippingDetails?.packages, packingSessionId, packingSession?.packing_boxes?.length, packingReadOnly, orderLoaded, hasNoScannableItems, boxOpenSignal])

  const skuForProduct = product => product?.product_codes?.find(pc => pc.sku)?.sku || `id-${product?.id}`

  // Scan / packing refusals keyed by the backend code. The literal messages live in the
  // catalog object generate_shipment.multi_box.scan_errors (es + pt), grouped there by flow:
  // scan, bulk-scan, change-empaque (PATCH /shipping-package), conclude (POST /conclude),
  // delete / regenerate-label, close / regenerate-label per-stage failures (CUBBO-2067
  // batch 2), BR / NF-e, IMEI handling (has_imei products on /scan and /close) and container
  // scans (CUBBO-2689: its pieces enter the active box at once; `invalid_code` and
  // `invalid_scan_kind` are left out because the backend cannot answer us with them, and
  // scan_needs_confirmation has no confirmation UI on purpose: there are no such collisions
  // today, and scanning piece by piece is the way through). returnObjects runs at render,
  // so the map follows the warehouse language.
  const SCAN_ERROR_MESSAGES = {
    ...i18n.t('generate_shipment.multi_box.scan_errors', { returnObjects: true }),
    packing_bulk_add_disabled: i18n.t('generate_shipment.multi_box.bulk_add_disabled'),
    // The conclude-path codes BUGS-8257 added: the same packing_incomplete is localized on
    // the label path (errorMessages.js -> es/pt); this is the conclude wording.
    override_not_authorized: i18n.t('generate_shipment.multi_box.conclude_override_not_authorized'),
    packing_incomplete: i18n.t('generate_shipment.multi_box.conclude_packing_incomplete'),
    // Package-level refusals from opening a box / changing its empaque. The backend's
    // `error` for these is raw English with ids, so the code must win over it.
    PACKAGE_NOT_ALLOWED_FOR_STORE: i18n.t('fulfillment_errors.error_codes.PACKAGE_NOT_ALLOWED_FOR_STORE'),
    PACKAGE_VALIDATION_FAILED: i18n.t('fulfillment_errors.error_codes.PACKAGE_VALIDATION_FAILED'),
  }

  // Defensive drain triggered from setTimeout when persistScanToBox queues
  // a scan. The useEffect-based drain (line ~1030) covers the case where
  // packingSession changes, but if its data stays referentially equal
  // (setQueryData with identical payload, for example), the effect doesn't
  // re-run and the queued scan is stranded until the next 3s poll.
  const retryPendingScans = () => {
    if (!pendingScansRef.current.length && !pendingContainerScansRef.current.length) return
    // The ref, not the state: one of the schedule sites below fires from a render
    // where the session did not exist, freezing a null state.
    const sessionId = packingSessionIdRef.current
    if (!sessionId) return
    const cached = queryClient.getQueryData(['packingSession', sessionId]) || packingSession
    const hasOpenBox = (cached?.packing_boxes || []).some(b => b.status !== 'closed')
    if (!hasOpenBox) return
    const pending = [...pendingScansRef.current]
    pendingScansRef.current = []
    pending.forEach(({ code, imei, productId }) => persistScanToBox(code, imei, productId))
    drainPendingContainerScans()
  }

  const drainPendingContainerScans = () => {
    const pending = [...pendingContainerScansRef.current]
    pendingContainerScansRef.current = []
    pending.forEach(code => scanContainerIntoBox(code))
  }

  // Undo one optimistic increment against the LIVE map: a retried scan carries a
  // closure whose snapshot predates the session, and writing that back would
  // discard every increment since. Pure, because StrictMode runs updaters twice.
  const rollbackReviewedCount = productId => {
    setProductsToReviewById(prev => {
      const live = prev[productId]
      if (!live || (live.reviewedItemsCount || 0) <= 0) return prev
      return { ...prev, [productId]: { ...live, reviewedItemsCount: live.reviewedItemsCount - 1 } }
    })
  }

  const persistScanToBox = (scannedCode, imei = null, knownProductId = null) => {
    if (!scannedCode) return
    // The first scans after entering a multi-box order race against
    // lookup → create → open-box (can take ~500ms total). If the session
    // or a target box isn't ready yet, queue the code; the drain effect
    // below replays it as soon as both are available.
    // The ref, not the state: the retry above runs from a closure whose state is
    // frozen, so gating on the state there would re-queue forever.
    const sessionId = packingSessionIdRef.current
    if (!sessionId) {
      pendingScansRef.current.push({ code: scannedCode, imei, productId: knownProductId })
      // Schedule a defensive retry — if for some reason the drain
      // useEffect doesn't fire (e.g., packingSession ref didn't change
      // because setQueryData wrote equal data), this still drains.
      setTimeout(() => retryPendingScans(), 400)
      return
    }
    const currentActiveBoxId = activeBoxIdRef.current
    // Use the cache first (freshest sync read) but fall back to the
    // useQuery `packingSession` from this render's closure — covers the
    // race where setPackingSessionId is committed but the cache lookup
    // returns undefined for a single tick.
    const cached = queryClient.getQueryData(['packingSession', sessionId]) || packingSession
    const liveBoxes = cached?.packing_boxes || []
    const activeBox = liveBoxes.find(b => b.id === currentActiveBoxId)
    const targetBox = activeBox && activeBox.status !== 'closed' ? activeBox : liveBoxes.find(b => b.status !== 'closed')
    if (!targetBox) {
      // No open backend box for this scan. Two reasons matter:
      //   1) Session not bootstrapped yet (no cached boxes) → queue.
      //   2) There ARE boxes (all closed) but the operator scanned with
      //      nowhere to put the unit. Either they:
      //        - already added a placeholder card and need to pick its
      //          empaque, OR
      //        - need to add a new caja.
      //      We surface a single action-oriented message that covers
      //      both cases + auto-focus the empaque combobox so the
      //      placeholder (if any) opens its package selector.
      if (liveBoxes.length > 0) {
        // Heuristic: any null slot in shippingDetails.packages OR an
        // overall packages_count > backend box count means there's a
        // virtual placeholder waiting for empaque selection.
        // Read from the ref (always latest) — the SearchInput debounce
        // captures persistScanToBox in a useCallback whose deps are
        // [productsToReviewById]. If shippingDetails changes (e.g.
        // operator clicked "Añadir otra caja" → packages_count goes
        // 11 → 12) BUT productsToReviewById didn't, the debounced
        // closure points to a stale persistScanToBox whose
        // `shippingDetails` is the pre-Añadir value (1, in the bug
        // report). Reading from the ref bypasses the stale closure.
        const liveShippingDetails = shippingDetailsRef.current || shippingDetails
        const uiPackages = liveShippingDetails?.packages || []
        const uiPackagesCount = liveShippingDetails?.packages_count || 0
        const hasNullSlot = uiPackages.some(p => !p)
        const hasVirtualPlaceholder = hasNullSlot || uiPackagesCount > liveBoxes.length
        if (hasVirtualPlaceholder) {
          setAlert(i18n.t('generate_shipment.multi_box.pick_empaque_first_alert'))
          setPackageFocusSignal(prev => prev + 1)
        } else {
          setAlert(i18n.t('generate_shipment.multi_box.no_open_box_alert'))
        }
        // Undo the optimistic reviewedItemsCount++ that happened in
        // increaseReviewedItemsCount before this function ran. Prefer
        // the productId the caller already knows (the source of truth
        // for which row was incremented) — falling back to code-based
        // resolution would decrement the wrong row when two products
        // in the order share a UPC/bar_code.
        let matchingProduct = knownProductId ? productsToReviewById[knownProductId] : null
        if (!matchingProduct) {
          matchingProduct = Object.values(productsToReviewById).find(p => productCodeBelongsToProduct(p, scannedCode))
        }
        if (matchingProduct) {
          rollbackReviewedCount(matchingProduct.id)
          releaseUnitCode(matchingProduct.id, scannedCode)
        }
        return
      }
      pendingScansRef.current.push({ code: scannedCode, imei, productId: knownProductId })
      setTimeout(() => retryPendingScans(), 400)
      return
    }
    if (targetBox.id !== currentActiveBoxId) {
      setActiveBoxId(targetBox.id)
    }
    // Optimistic UI: drop a placeholder into a SEPARATE state (not the
    // React Query cache). The cache is wholesale-replaced by every
    // polling refetch and invalidate — if placeholders lived there they'd
    // get wiped before the server confirms the first scan, producing the
    // "appear → disappear → reappear" flicker (worst on the very first
    // scan of an empty caja). Keeping placeholders in a separate state
    // makes them survive cache refreshes; the sessionBoxes derivation
    // merges them in at render time.
    const optimisticProduct = knownProductId
      ? productsToReviewById[knownProductId]
      : Object.values(productsToReviewById).find(p => productCodeBelongsToProduct(p, scannedCode))
    const placeholderId = `opt-${Date.now()}-${Math.floor(Math.random() * 1e6)}`
    const placeholder = {
      id: placeholderId,
      sku: optimisticProduct ? skuForProduct(optimisticProduct) : null,
      product_id: optimisticProduct?.id || null,
      product_code: scannedCode,
      _optimistic: true,
    }
    const targetBoxId = targetBox.id
    setOptimisticUnitsByBoxId(prev => ({
      ...prev,
      [targetBoxId]: [...(prev[targetBoxId] || []), placeholder],
    }))
    // Helper to remove THIS placeholder once the request settles.
    const dropPlaceholder = () => {
      setOptimisticUnitsByBoxId(prev => {
        const next = { ...prev }
        const arr = (next[targetBoxId] || []).filter(u => u.id !== placeholderId)
        if (arr.length === 0) delete next[targetBoxId]
        else next[targetBoxId] = arr
        return next
      })
    }
    // ONE /scan in flight per caja (FIFO). The backend row-locks the box, so N
    // parallel POSTs — the pending-scan drain, a fast burst — queue server-side
    // and the last one waits N × ~100ms; past ~25s Rack::Timeout kills it
    // (500) and every one of those rolled the count back and told the
    // operator to rescan. Serializing here keeps each scan fast and the
    // responses in order.
    // Idempotency key of THIS attempt. On a transient failure (network error,
    // Rack::Timeout 500, H12 503 — the request MAY have committed before the
    // response was lost) scanWithReplay re-POSTs the SAME key inside the queue
    // slot: the backend replays the already-packed unit or packs now, so the
    // answer is authoritative for this exact attempt. No count thresholds, no
    // cache reads — a burst shares stale snapshots (false confirm → caja ships
    // a piece short) and an in-flight poll predating the scan reads a stale
    // count (false rollback → the rescan packs a SECOND unit).
    const scanKey = typeof crypto !== 'undefined' && crypto.randomUUID ? crypto.randomUUID() : placeholderId
    scanQueueRef.current
      .enqueue(targetBoxId, () => scanWithReplay(() => scanUnitIntoBox(targetBoxId, scannedCode, imei, scanKey)))
      .then(res => {
        // Merge the response into the cache — the slim shape APPENDS only what
        // this scan added; a legacy full box replaces wholesale (kept for the
        // deploy window). A 200 settles THIS attempt (packed, or replayed as
        // already packed), so the placeholder goes now — the real unit from the
        // response takes its place.
        queryClient.setQueryData(['packingSession', sessionId], old => applyScanResponse(old, res))
        dropPlaceholder()
      })
      .catch(err => {
        // Definitive 4xx, or a transient failure whose single same-key replay
        // also failed. Roll back BOTH the placeholder (state) AND the local
        // reviewedItemsCount bump (done in increaseReviewedItemsCount before
        // this function ran) and show the error: an unnecessary rescan is
        // recoverable, a silently-confirmed missing piece is not.
        dropPlaceholder()
        const rollbackProduct = knownProductId
          ? productsToReviewById[knownProductId]
          : Object.values(productsToReviewById).find(p => productCodeBelongsToProduct(p, scannedCode))
        if (rollbackProduct) {
          rollbackReviewedCount(rollbackProduct.id)
          releaseUnitCode(rollbackProduct.id, scannedCode)
        }
        const code = err?.response?.data?.code
        const friendly = SCAN_ERROR_MESSAGES[code]
        setErrorMessage(friendly || err?.response?.data?.error || i18n.t('generate_shipment.multi_box.could_not_register_unit'))
      })
  }

  const removeProductFromBox = (boxIdx, sku) => {
    // `sku` here is the grouping key from `box.items` — may be the SKU, a
    // UPC, a bar_code, or a synthetic `unit-N` fallback. Match against
    // any product_code on the product so we still find the right line.
    const product = Object.values(productsToReviewById).find(
      p => skuForProduct(p) === sku || p?.product_codes?.some(pc => pc.sku === sku || pc.upc === sku || pc.bar_code === sku),
    )
    // Skip synthetic + optimistic placeholders — their `id` doesn't
    // exist on the backend and unscanUnit would 404.
    const box = sessionBoxes[boxIdx]
    const realPackedUnits = (box?.packed_units || []).filter(u => !u._synthetic && !u._optimistic)
    const lastPacked = [...realPackedUnits].reverse().find(u => packedUnitKey(u) === sku)
    if (!box || !lastPacked) {
      // Nothing to unscan on backend — no-op locally too. The poll will
      // catch any drift.
      return
    }
    // Do NOT lower reviewedItemsCount optimistically. The reviewed-count
    // resync effect (see the "bring reviewedItemsCount in sync" effect above)
    // only ever INCREASES the count to match the real packed_units. If we drop
    // the count while the unit is STILL cached, that effect re-inflates it —
    // and once the unit is finally removed and the product drops out of the
    // packed-count map, it can never come back down: the last removed piece
    // stayed stuck at 1/N (CUBBO-2440 e). Mirror the bulk-remove path instead:
    // update the cache FIRST (unit gone), THEN lower the count, so the count
    // is never below the cached packed_units and the resync can't re-inflate.
    unscanUnit(box.id, lastPacked.id)
      .then(updatedBox => {
        queryClient.setQueryData(['packingSession', packingSessionId], old => {
          if (!old) return old
          return {
            ...old,
            packing_boxes: (old.packing_boxes || []).map(b => (b.id === updatedBox.id ? { ...b, ...updatedBox } : b)),
          }
        })
        if (product && (productsToReviewById[product.id]?.reviewedItemsCount || 0) > 0) {
          productsToReviewById[product.id].reviewedItemsCount = Math.max(0, (productsToReviewById[product.id].reviewedItemsCount || 0) - 1)
          setProductsToReviewById({ ...productsToReviewById })
        }
        // The unit left the box, so its card must be scannable again.
        const unitCode = (data?.order_lines || []).flatMap(ol => ol.stock_units || []).find(su => su.id === lastPacked.stock_unit_id)?.unit_code
        if (product && unitCode) releaseUnitCode(product.id, unitCode)
      })
      .catch(err => {
        setErrorMessage(err?.response?.data?.error || i18n.t('generate_shipment.multi_box.could_not_unscan'))
      })
  }

  const capturedUnitCodes = () => (shipment.productsData || []).flatMap(pd => pd.unit_codes || [])

  const releaseUnitCode = (productId, code) => {
    const current = shipmentRef.current
    dispatch(setShipmentData({ ...current, productsData: withoutUnitCode(current.productsData, productId, code) }))
  }

  // Records the unit code on the piece and counts it. The unit code is also what goes to
  // the box scan: the backend resolves it to that exact unit, where a product code would
  // pack whichever picked unit comes first.
  const captureUnitCode = (productId, code) => {
    const newProductsData = cloneDeep(shipment.productsData)
    const alreadyScannedProductIndex = newProductsData.findIndex(pd => pd.product_id === productId)
    if (alreadyScannedProductIndex === -1) {
      newProductsData.push({
        product_id: productId,
        unit_codes: [code],
      })
    } else {
      newProductsData[alreadyScannedProductIndex].unit_codes = [...(newProductsData[alreadyScannedProductIndex].unit_codes || []), code]
    }

    dispatch(
      setShipmentData({
        ...shipment,
        productsData: newProductsData,
      }),
    )

    increaseReviewedItemsCount(productId, code)
  }

  const handleUnitCodeSubmit = code => {
    captureUnitCode(unitCodeReviewedProductId, code)
    setOpenDialogUnitCode(false)
  }

  const increaseReviewedItemsCount = function (productId, scannedCode = null, imei = null) {
    productsToReviewById[productId].reviewedItemsCount++
    // This is necessary to make the object feel the change.
    setProductsToReviewById({ ...productsToReviewById })
    // Ping packing-audit start on the first item that is actually reviewed
    // (IMEI/unit-code scans only count once their dialog completes).
    maybePingPackingAuditStart()
    // Forward productId so persistScanToBox can undo by id (not by code
    // lookup) when the scan can't land — necessary when two products in
    // the order share a UPC/bar_code.
    persistScanToBox(scannedCode, imei, productId)
  }

  useEffect(() => {
    if (imeiRegex) {
      setOpenDialogImei(true)
    }
  }, [imeiRegex])

  const isRemoveStockOrder = data?.order_type === 'REMOVE_STOCK'

  const handleProductReview = function (product, scannedCode = null) {
    if (product.has_imei && !isRemoveStockOrder) {
      // IMEI takes priority; a product shouldn't have both flags
      setReviewedProductId(product.id)
      // Stash the product code so handleImeiSubmit can send it along
      // with the captured IMEI in the /scan body.
      setReviewedProductCode(scannedCode)
      let imeiRegex = null
      const product_skus = product.product_codes.map(productCode => productCode.sku)
      const imeiConfigurationStore = imeiValidationConfiguration?.product_specific_configurations?.find(productConfiguration =>
        productConfiguration?.skus?.some(sku => product_skus.includes(sku)),
      )
      if (!imeiConfigurationStore) imeiRegex = imeiValidationConfiguration.global_imei_validation_regex
      else imeiRegex = imeiConfigurationStore.imei_validation_regex
      setImeiRegex(prev => {
        if (prev === imeiRegex) {
          setOpenDialogImei(true)
        }
        return imeiRegex
      })
      return
    }

    if (product.requires_unit_code && !isRemoveStockOrder) {
      // product.id === order_line.product.id — same entity from the same API response
      const orderLine = data?.order_lines?.find(ol => ol.product?.id === product.id)
      const allowed = (orderLine?.stock_units || []).map(su => su.unit_code).filter(Boolean)

      if (allowed.length === 0) {
        setAlert(i18n.t('generate_shipment.unit_code_missing_for_stock_unit'))
        return
      }

      setUnitCodeReviewedProductId(product.id)
      setUnitCodeAllowed(allowed)
      setOpenDialogUnitCode(true)
      return
    }

    increaseReviewedItemsCount(product.id, scannedCode)
  }

  const productCodeBelongsToProduct = (product, productCode) =>
    product.bar_code === productCode || product.product_codes.some(productCodes => productCodes.sku === productCode || productCodes.upc === productCode)

  // First-scan ping (§8.2): tell the server packing started on an audited order.
  // Fires once per session; the server is idempotent, so on error we clear the
  // flag to allow a later scan to retry.
  const maybePingPackingAuditStart = () => {
    if (!auditRequired || auditStartPingedRef.current) return
    auditStartPingedRef.current = true
    startPackingAudit(id).catch(() => {
      auditStartPingedRef.current = false
    })
  }

  // A code this order doesn't own may still be a caja or tarima. Scanning one is a
  // shortcut for scanning its pieces, and nothing about the container is modelled
  // here. The codes the backend answers with when it read the scan as a piece take
  // the warning dialog, which is the case that dialog already covered.
  const scanContainerIntoBox = code => {
    if (!code) return
    const sessionId = packingSessionIdRef.current
    const cached = sessionId ? queryClient.getQueryData(['packingSession', sessionId]) || packingSession : null
    const boxes = cached?.packing_boxes || []

    if (!sessionId) {
      // Outside the multi-box flow containers do not apply, so this is an unknown
      // code: the dialog, as before. Inside it, the session is still bootstrapping
      // (lookup → create → open box), so queue the code the way piece scans do
      // instead of rejecting a container that is valid.
      if (!willUseMultiBox) {
        setWarningDialogCode(code)
        setOpenWarningDialog(true)
        return
      }
      pendingContainerScansRef.current.push(code)
      setTimeout(() => retryPendingScans(), 400)
      // Nothing may sit in the queue without the operator hearing about it. Long
      // enough not to race a slow bootstrap.
      setTimeout(() => {
        const stranded = pendingContainerScansRef.current
        pendingContainerScansRef.current = []
        if (!stranded.length) return
        if (packingSessionIdRef.current) {
          // Session arrived but no box drained it, because a box waits for its
          // empaque. Let each scan report itself.
          stranded.forEach(strandedCode => scanContainerIntoBox(strandedCode))
          return
        }
        // No session at all: the order never gets one. One blocking dialog stops
        // the operator, so the rest of the batch adds nothing.
        setWarningDialogCode(stranded[0])
        setOpenWarningDialog(true)
      }, 3000)
      return
    }

    const targetBox = pickTargetBox(boxes, activeBoxIdRef.current)
    if (!targetBox) {
      // A session with no open box is a box problem, not an unknown code —
      // including a session whose first box is still waiting for its empaque.
      const liveShippingDetails = shippingDetailsRef.current || shippingDetails
      const uiPackages = liveShippingDetails?.packages || []
      const slotCount = liveShippingDetails?.packages_count || uiPackages.length
      // A brand-new session shows one slot with an empty `packages`, so read the
      // slots the UI renders instead of the array's own contents.
      const awaitingEmpaque = Array.from({ length: slotCount }, (_, i) => uiPackages[i]).some(pkg => !pkg)
      setAlert(i18n.t(awaitingEmpaque ? 'generate_shipment.multi_box.pick_empaque_first_alert' : 'generate_shipment.multi_box.no_open_box_alert'))
      if (awaitingEmpaque) setPackageFocusSignal(prev => prev + 1)
      return
    }

    const releaseContainerScan = () => {
      containerScanInFlightRef.current = false
      drainPendingContainerScans()
    }

    // A container scan packs N units, so they go one at a time. The same code
    // arriving again is the scanner double-firing and is dropped; a different one
    // waits its turn.
    if (containerScanInFlightRef.current) {
      if (containerScanInFlightRef.current !== code) {
        pendingContainerScansRef.current.push(code)
      } else {
        // A repeat may be the scanner double-firing or a second caja sharing the
        // code, and nothing here can tell them apart — so say it, don't guess.
        setErrorMessage(i18n.t('generate_shipment.multi_box.container_scan_in_flight'))
      }
      return
    }
    containerScanInFlightRef.current = code
    if (targetBox.id !== activeBoxIdRef.current) setActiveBoxId(targetBox.id)
    scanUnitIntoBox(targetBox.id, code)
      .then(updatedBox => {
        // Deliberately after the response, unlike the piece path: an unrecognised
        // code must not stamp the audit as started.
        maybePingPackingAuditStart()
        // An accepted scan must not be reported as a failure just because the body
        // came back empty; the 3s poll catches the counts up.
        if (!updatedBox?.id) return
        // The counts follow packed_units through the reviewedItemsCount sync
        // effect, so nothing is added up here.
        queryClient.setQueryData(['packingSession', sessionId], old => {
          if (!old) return old
          return {
            ...old,
            packing_boxes: (old.packing_boxes || []).map(b => (b.id === updatedBox.id ? { ...b, ...updatedBox } : b)),
          }
        })
      })
      .catch(err => {
        const errorCode = err?.response?.data?.code
        if (isNotAContainer(errorCode)) {
          setWarningDialogCode(code)
          setOpenWarningDialog(true)
          return
        }
        setErrorMessage(SCAN_ERROR_MESSAGES[errorCode] || getBackendErrorMessage(err) || i18n.t('generate_shipment.multi_box.could_not_register_unit'))
      })
      .then(releaseContainerScan, releaseContainerScan)
  }

  const addProducts = productCode => {
    if (productCode === '' || productCode === null) {
      return
    }
    productCode = productCode.trim()
    setAlert(false)
    // Multi-box: a scan with no packing session to land in is NOT progress.
    // Counting it locally and queueing it in silence let operators "pack" a
    // whole caja that never reached the backend (and drained later as a burst
    // of parallel POSTs). Tell them why, keep the input alive, and stop here.
    if (useNewPackingUI && !packingSessionId && sessionStartBlockedCode) {
      // Translated status (the raw backend token read as jargon inside an
      // otherwise localized sentence); unknown statuses fall back to the token.
      const statusLabel = data?.status ? i18n.t(`statuses.order_statuses.${data.status}`, { defaultValue: data.status }) : '—'
      setAlert(i18n.t('generate_shipment.multi_box.session_not_ready_alert', { status: statusLabel }))
      inputRef.current?.resetInput()
      inputRef.current?.setIsSearchDisabled(false)
      inputRef.current?.focus()
      return
    }
    const reviewedProduct = Object.values(productsToReviewById).find(product => {
      if (product.reviewedItemsCount == null) product.reviewedItemsCount = 0

      const hasSurplus = product.reviewedItemsCount > product.quantity

      if (hasSurplus) setAlert(i18n.t('generate_shipment.surplus_product'))

      const isReviewCompleted = product.reviewedItemsCount === product.quantity

      if (isReviewCompleted || hasSurplus) return false

      return productCodeBelongsToProduct(product, productCode)
    })

    // A piece whose only barcode is its unit code is identified by that code alone.
    const unitCodeProduct =
      reviewedProduct || isRemoveStockOrder
        ? undefined
        : productForUnitCode(Object.values(productsToReviewById), data?.order_lines, productCode, capturedUnitCodes())

    if (reviewedProduct) {
      handleProductReview(reviewedProduct, productCode)
    } else if (unitCodeProduct) {
      captureUnitCode(unitCodeProduct.id, productCode)
    } else if (orderContainsCode(data?.order_lines, productCode)) {
      // The order owns this code — a completed line, a non-scannable product, or a
      // unit code — so it must not travel as a container.
      setWarningDialogCode(productCode)
      setOpenWarningDialog(true)
    } else {
      scanContainerIntoBox(productCode)
    }

    setLatestAddedProduct(reviewedProduct || unitCodeProduct)

    inputRef.current?.resetInput()
    inputRef.current?.setIsSearchDisabled(false)
    inputRef.current?.focus()
  }
  const trackingNumberCorreios = useMemo(() => {
    if (trackingNumber) {
      return trackingNumber
    } else return null
  }, [trackingNumber])

  const validQualityCheck = useMemo(() => {
    let totalItemsToReview = 0
    let totalReviewedItems = 0

    Object.values(productsToReviewById).forEach(product => {
      totalItemsToReview += product.quantity
      totalReviewedItems += product.reviewedItemsCount || 0
    })
    return totalItemsToReview === totalReviewedItems
  }, [productsToReviewById])

  // Number of successful item scans this packing session — sent as `scans_count`
  // when answering the packing audit (§8.5).
  const scansCount = useMemo(
    () => Object.values(productsToReviewById).reduce((accumulator, product) => accumulator + (product.reviewedItemsCount || 0), 0),
    [productsToReviewById],
  )

  const userValid = useMemo(() => {
    return user.permissions.generate_additional_labels
  }, [user])

  useEffect(() => {
    if (validQualityCheck && !previousValidQualityCheck.current) {
      setPackageFocusSignal(previousSignal => previousSignal + 1)
    }
    previousValidQualityCheck.current = validQualityCheck
  }, [validQualityCheck])

  const validateShippingAddressForm = useMemo(() => {
    if (
      shippingDetails.shippingMethod?.shipping_type !== 'pickup' &&
      ((requiresZipcode && shippingAddress.zipCode === '') ||
        shippingAddress.city === '' ||
        shippingAddress.province === '' ||
        !shippingAddress.country ||
        shippingAddress.country.value === '' ||
        shippingAddress.first_name === '' ||
        shippingAddress.address === '')
    ) {
      setErrorMessage(i18n.t('generate_shipment.missing_information'))
      return false
    }
    // if (shippingDetails.shippingMethod?.carrier_name === "DHL" && shippingAddress.phone === "") {
    //     setErrorMessage("Falta información en la orden")
    //     return false
    // }

    return true
  }, [shippingAddress, shippingDetails, requiresZipcode])

  const enforcePackagesCountLimit = (newValue, previousValue) => (newValue > 0 && newValue <= 50 ? newValue : previousValue)

  const ValidShippingLabels = useMemo(() => {
    setErrorMessage(null)
    // Only real carrier guides count as "already has a guide" (see carrierLabels).
    return carrierLabels.length > 0
  }, [carrierLabels])

  // Re-emitting a guide the order already carries from somewhere OTHER than this
  // screen's per-box closes: already shipped, scenario B's bulk generate, or an
  // async-generated guide still in `packing`. The predicate keys on the label's
  // provenance, NOT on the session boundary — see isReemission for the three shapes and
  // for why scenario A is excluded. Those shipments were packed when their guide was
  // minted and the legacy screen has no session to restore the scan counters from, so
  // demanding a complete count here would force a re-scan of a shipment already boxed.
  // This leaves one asymmetry, pre-existing and deliberate: on a re-emission the grant
  // holder is waived where a non-grant user still needs the count complete, and in some
  // shapes is refused outright by blockedByExistingLabel below. It is safe because the
  // server gate does not honor the browser's re-emission waiver — if pieces are genuinely
  // in the tote, generate_label and conclude refuse the request regardless of role
  // (BUGS-8257).
  const isLabelReemission = isReemission({ alreadyHasLabels, hasCarrierLabels: ValidShippingLabels, hasPerBoxLabels: observedPerBoxLabels })

  const formValid = useMemo(() => {
    if (busyPackageSelection) return false
    if (!areShippingPackagesValid) return false
    // Packing audit gate (§8.3): an audited order must be FULLY scanned AND have the
    // three questions answered before a label can be generated. The audit forces the
    // scan even for stores that normally skip it (e.g. Natura) — it mirrors the legacy
    // addon, which only revealed the questions once the page showed "O pedido está
    // completo!" — so it has to sit ABOVE the store exemption that canGenerateFirstLabel
    // applies further down.
    if (auditRequired && !(validQualityCheck && auditLocallyAnswered)) return false
    if (!validateShippingAddressForm) return false

    const storeId = data?.store?.id
    if (!userValid) {
      // An async-generated label still in packing is a half-finished generation, not
      // an "additional" label — re-generating just finishes the order, so don't block
      // it behind the elevated grant.
      const blockedByExistingLabel = ValidShippingLabels && !asyncGeneratedPendingLabels
      if (blockedByExistingLabel) {
        setErrorMessage(i18n.t('generate_shipment.cannot_generate_more_labels'))
        return false
      }
      return canGenerateFirstLabel({ validQualityCheck, isLabelReemission: false, storeId })
    }
    // `generate_additional_labels` authorizes a guide for an order that already has
    // one. `return userValid` turned it into a quality-check waiver for every
    // supervisor, which is how orders shipped with pieces still in the tote
    // (BUGS-8257). The first guide needs the count complete for everyone; a
    // re-emission keeps the legacy behavior.
    return canGenerateFirstLabel({ validQualityCheck, isLabelReemission, storeId })
  }, [
    data,
    validQualityCheck,
    validateShippingAddressForm,
    userValid,
    ValidShippingLabels,
    asyncGeneratedPendingLabels,
    isLabelReemission,
    areShippingPackagesValid,
    busyPackageSelection,
    auditRequired,
    auditLocallyAnswered,
    i18n,
  ])

  // Build the print-cascade queue for a closed PaqueteCard so the preview
  // walks through every available document for the box (packing list →
  // etiqueta → factura/NF-e) — same UX as the normal end-of-order flow but
  // scoped to a single caja. `startWith` decides which doc opens first.
  const buildBoxDocsQueue = (box, boxIdx) => {
    const docs = []
    if (box?.packing_list_url)
      docs.push({
        key: 'packing_list',
        title: i18n.t('generate_shipment.print_titles.box_packing_list', { n: boxIdx + 1 }),
        type: 'document',
        file_path: box.packing_list_url,
      })
    if (box?.shipping_label_url)
      docs.push({
        key: 'shipping_label',
        title: i18n.t('generate_shipment.print_titles.box_shipping_label', { n: boxIdx + 1 }),
        type: 'label',
        file_path: box.shipping_label_url,
      })
    if (box?.invoice_url)
      docs.push({
        key: 'invoice',
        title: i18n.t('generate_shipment.print_titles.box_invoice', { n: boxIdx + 1 }),
        type: 'document',
        file_path: box.invoice_url,
      })
    return docs
  }

  const startBoxDocsChain = (boxIdx, startWithKey) => {
    const box = sessionBoxes[boxIdx]
    if (!box) return
    const docs = buildBoxDocsQueue(box, boxIdx)
    const startIdx = Math.max(
      0,
      docs.findIndex(d => d.key === startWithKey),
    )
    // Rotate so the requested doc opens first, the rest follow in order.
    const ordered = [...docs.slice(startIdx), ...docs.slice(0, startIdx)]
    if (!ordered.length) return
    const [first, ...rest] = ordered
    setPrintInformation({
      ...first,
      use_absolute_url: true,
      simpleClose: true,
      boxDocsQueue: rest,
    })
    setOpenDialogDocument(true)
  }

  const print = (title, path, type, opts = {}) => {
    setOpenDialogDocument(false)
    // Clean object (no spread of printInformation): do not inherit a stale
    // use_absolute_url from a per-box preview, which would make LabelView treat the
    // blob's relative path as absolute and the <embed> load against the
    // WMS origin (SPA fallback -> home) instead of REACT_APP_PLATFORM_URL.
    // opts.simpleClose is passed by reprints so that closing/printing the
    // preview only closes the dialog (without navigating away from the order).
    setPrintInformation(buildGenericPrintInfo(title, path, type, opts))
    setOpenDialogDocument(true)
  }

  const shippingDocumentsToBePrinted = (shippingLabels = data?.shipping_labels, documents = shippingDocuments) =>
    filterPrintableShippingDocuments(documents, shippingLabels)
  const shippingLabelsToBePrinted = () => extraShippingLabels.filter(shippingLabel => !shippingLabel.print)

  const printShippingDocument = function (documentToPrint, baseDocuments = shippingDocuments) {
    // Callers inside the post-generate setTimeout pass the freshly-refetched
    // documents; the default `shippingDocuments` closure is the stale mount
    // snapshot and rebuilding state from it would drop the just-created guide.
    const shipping_documents = baseDocuments.map(sd => (sd.id === documentToPrint.id ? { ...sd, print: true } : sd))
    setShippingDocuments([...shipping_documents])

    print(i18n.t('generate_shipment.print_titles.shipping_documents'), documentToPrint.file.path, documentToPrint.printing_type)
  }

  const printExtraShippingLabels = function (labelToPrint) {
    const shipping_labels = extraShippingLabels.map(sl => (sl.id === labelToPrint.id ? { ...sl, print: true } : sl))
    setExtraShippingLabels([...shipping_labels])

    print(i18n.t('generate_shipment.print_titles.extra_shipping_labels'), labelToPrint.label_file.path, 'label')
  }

  const singleClickPrintEnabled = data?.single_click_packing_print_enabled === true

  const printBundles = async (labels, documents, primaryLabel, onGateClosed) => {
    const sources = buildPrintSources({
      primaryLabel,
      extraLabels: extraShippingLabels,
      printableDocuments: shippingDocumentsToBePrinted(labels, documents),
      allLabels: labels?.length ? labels : (data?.shipping_labels ?? []),
      shippingType: effectiveShippingDetails?.shippingMethod?.shipping_type,
      packagesCount: effectiveShippingDetails?.packages_count,
    })

    let outcome
    if (!sources.length) {
      outcome = resolveBundleOutcome({ sources })
    } else {
      try {
        outcome = resolveBundleOutcome({ sources, response: await getPackingPrintBundle(id, sources) })
      } catch (error) {
        outcome = resolveBundleOutcome({ sources, error })
      }
    }

    if (outcome.action === 'cascade') {
      // Silent by design: the packer keeps printing on the old flow. A warehouse that never
      // reaches bundle mode is no longer visible anywhere, which is a gap worth reopening.
      onGateClosed?.()
      return
    }

    setPrintInformation({
      title: outcome.skipped > 0 ? i18n.t('generate_shipment.print_bundle_with_skipped', { count: outcome.skipped }) : i18n.t('generate_shipment.print_bundle'),
      bundles: outcome.bundles,
      skipped: outcome.skipped,
    })
    setOpenDialogDocument(true)
  }

  useHotkeys(
    'ctrl+g',
    () => {
      // handleGenerateLabel() stays commented out on purpose: it ENDS by opening the confirm
      // dialog, so calling it here would add a confirmation click the shortcut does not have
      // today. What the shortcut was missing is the validation head, which is now shared.
      // The shortcut used to check only formValid, so it emitted guides the footer was
      // refusing — with cajas still open, the camera blocked, or an unanswered packing
      // audit (BUGS-8257: an 1,821-piece REM shipped with 0 pieces packed this way).
      if (
        labelEmissionBlocked({
          formValid,
          multiBoxAwaitingClosedBoxes,
          shouldBlockPreventively,
          packingAuditBlocked,
          readOnly: useNewPackingUI && packingReadOnly,
        }) ||
        // Scenario A is finalized with POST /conclude, which only the footer does.
        // Falling through to the bulk onConfirmGenerateLabelHandler below would
        // double-mint (and double-bill) the guides each /close already produced, and
        // the completeness gate does not catch that — it refuses INCOMPLETE packings,
        // not duplicate labels. So the shortcut refuses; routing stays the footer's
        // job and the message below sends the operator to the button.
        isPerBoxLabelScenario
      ) {
        setLoading(false)
        // Never return mute: this branch covered one condition before BUGS-8257 and
        // now covers six, three of which a supervisor hits routinely (a caja still
        // open, the camera blocked, an unanswered packing audit). A silent no-op read
        // as "the order closed" and was filed as a bug (BUGS-8259). The footer's
        // button states the specific reason, so point there instead of guessing which
        // of the six fired.
        setErrorMessage(i18n.t('generate_shipment.shortcut_blocked_use_button'))
        return
      }

      const blockedReason = generationBlockedReason()
      if (blockedReason) {
        setLoading(false)
        setErrorMessage(i18n.t(blockedReason))
        return
      }

      setLoading(true)
      if (
        shippingDetails.shippingMethod.carrier_name === 'CORREIOS' &&
        (shippingDetails.shippingMethod.contract_provider === null || shippingDetails.shippingMethod.contract_provider === 'CORREIOS_PREPAID')
      ) {
        setOpenDialogCorreios(true)
      } else onConfirmGenerateLabelHandler()
      // data and shippingDetails added to the deps: without them the callback closes over the
      // state as of the last formValid change, so the checks above would judge a stale order
      // and a stale shipping method — worse than not checking at all.
      // effectiveShippingDetails is belt and braces: useHotkeys keys its memo on the
      // inline options object, so this callback is rebuilt every render and never held
      // a stale derivation. Listing it keeps that true if the options are ever hoisted.
    },
    { enableOnTags: ['INPUT', 'TEXTAREA', 'SELECT'] },
    [
      formValid,
      data,
      shippingDetails,
      effectiveShippingDetails,
      multiBoxAwaitingClosedBoxes,
      shouldBlockPreventively,
      packingAuditBlocked,
      packingReadOnly,
      useNewPackingUI,
      isPerBoxLabelScenario,
    ],
  )

  return (
    <>
      {!isMobile && (
        <div
          {...previewDragHandleProps}
          className="fixed z-40 rounded-lg overflow-hidden shadow-lg border border-gray-300 bg-gray-900 select-none touch-none"
          style={{
            width: MINI_PREVIEW_W,
            height: MINI_PREVIEW_H,
            left: previewPosition.x,
            top: previewPosition.y,
            cursor: previewIsDragging ? 'grabbing' : 'grab',
            display: hasBlockingOverlay ? 'none' : undefined,
          }}
          title={i18n.t('generate_shipment.camera_mini_preview_title')}
        >
          <video ref={miniPreviewRef} autoPlay muted playsInline className={`w-full h-full object-cover${miniPreviewIsReady ? '' : ' hidden'}`} />
          {!miniPreviewIsReady && miniPreviewError && (
            <button
              type="button"
              onClick={retryMiniPreview}
              onPointerDown={e => e.stopPropagation()}
              disabled={isMiniPreviewRetrying}
              aria-label={i18n.t(
                miniPreviewIsDenied ? 'generate_shipment.camera_mini_preview_pill.denied' : 'generate_shipment.camera_mini_preview_pill.unavailable',
              )}
              className="absolute inset-0 m-auto h-6 max-w-[140px] inline-flex items-center justify-center gap-1 px-2 py-1 rounded-full bg-red-600 hover:bg-red-700 text-white text-[10px] font-semibold leading-none shadow disabled:opacity-60 disabled:cursor-not-allowed"
            >
              <RefreshIcon className={`h-3 w-3 ${isMiniPreviewRetrying ? 'animate-spin' : ''}`} />
              <span className="truncate">
                {i18n.t(miniPreviewIsDenied ? 'generate_shipment.camera_mini_preview_pill.denied' : 'generate_shipment.camera_mini_preview_pill.unavailable')}
              </span>
            </button>
          )}
          {!miniPreviewIsReady && !miniPreviewError && (
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="animate-spin rounded-full h-4 w-4 border-t-2 border-b-2 border-white" />
            </div>
          )}
        </div>
      )}
      {!isPreviousData &&
      !warehousePackingMaterialsIsPreviousData &&
      !storePackingMaterialsIsPreviousData &&
      (isLoading ||
        isLoadingImeiValidationConfiguration ||
        isLoadingPackingOptions ||
        warehousePackingMaterialsIsLoading ||
        storePackingMaterialsIsLoading ||
        isLoadingOrderPackageRestrictions ||
        isLoadingOrderRecommendedShippingPackages) ? (
        <>
          <Loader show={true}></Loader>
        </>
      ) : isError ||
        isErrorImeiValidationConfiguration ||
        isErrorPackingOptions ||
        warehousePackingMaterialsIsError ||
        storePackingMaterialsIsError ||
        isErrorOrderPackageRestrictions ||
        isErrorOrderRecommendedShippingPackages ? (
        <div className="m-4 rounded border border-red-700 bg-red-600 px-4 py-3 text-white shadow">
          <div className="mb-1 font-semibold">{i18n.t('common.error') || 'Error'}</div>
          <ul className="list-disc list-inside text-sm space-y-0.5">
            {[
              ...new Set(
                [
                  getBackendErrorMessage(error),
                  getBackendErrorMessage(ImeiValidationConfigurationError),
                  getBackendErrorMessage(packingOptionsError),
                  getBackendErrorMessage(warehousePackingMaterialsError),
                  getBackendErrorMessage(storePackingMaterialsError),
                  getBackendErrorMessage(errorOrderPackageRestrictions),
                  getBackendErrorMessage(errorOrderRecommendedShippingPackages),
                ].filter(Boolean),
              ),
            ].map(msg => (
              <li key={msg}>{msg}</li>
            ))}
          </ul>
        </div>
      ) : (
        <PageView
          topMenu={
            <PageTopBar>
              <div className="text-lg font-semibold">
                {(userValid || shipment.store_id === 13861) && ( // Display order number only for Payjoy store
                  <>
                    <span className="text-gray-400"> {i18n.t('generate_shipment.generate_label')} &rarr; </span>
                    {i18n.t('common.order')}: #{shipment.order_number}
                    <span className="text-gray-400 ml-10"> {i18n.t('generate_shipment.store')} &rarr; </span>
                    {shipment.store_name}
                  </>
                )}

                <span className="text-gray-400 ml-10"> {i18n.t('generate_shipment.tote')} &rarr; </span>
                {shipment.tote}
              </div>

              {data.picking_order && data.picking_order.single_item_picking ? (
                <>
                  <ButtonLoader
                    type="secondary"
                    loading={loadingButtonLoader}
                    onClick={() => {
                      goToNextOrderInTote()
                    }}
                  >
                    {i18n.t('generate_shipment.go_to_next_order')}
                  </ButtonLoader>
                </>
              ) : (
                <></>
              )}
            </PageTopBar>
          }
          childrenFullWidth={true}
          topMenuFullWidth={true}
          bottomMenuStyles={'border-t-2'}
          errorMessage={errorMessage}
          bottomMenu={
            <GenerateShipmentFooter
              onSave={async () => {
                // Pre-close guard: warn the operator if there are reviewed
                // pieces that never made it into a caja (still "en tote").
                // The disabled gate already requires all boxes to be closed,
                // but doesn't catch units that were scanned and locally
                // bumped without persisting to a box (edge cases around
                // transient errors). Beta flow only — non-beta keeps the
                // legacy behavior.
                if (useNewPackingUI) {
                  const totalReviewed = Object.values(productsToReviewById).reduce((sum, p) => sum + (p.reviewedItemsCount || 0), 0)
                  const totalInBoxes = sessionBoxes.reduce((sum, b) => sum + Object.values(b.items || {}).reduce((s, n) => s + n, 0), 0)
                  if (totalReviewed > totalInBoxes) {
                    const inTote = totalReviewed - totalInBoxes
                    const ok = window.confirm(
                      inTote === 1
                        ? i18n.t('generate_shipment.multi_box.pre_close_warning_one', { count: inTote })
                        : i18n.t('generate_shipment.multi_box.pre_close_warning_other', { count: inTote }),
                    )
                    if (!ok) return
                  }
                }

                // Scenario A: shipping_method declares it supports per-box labels.
                // Each close already minted the carrier label, so the footer just
                // calls POST /conclude (no extra label generation, no re-billing).
                // Otherwise fall through to the existing bulk handleGenerateLabel.
                //
                // Defensive cross-check: if ANY closed box already has a
                // shipping_label_url, the carrier minted labels per-box even
                // when the flag is missing/undefined on the shipping_method.
                // Falling through to handleGenerateLabel in that state would
                // double-mint (and double-bill).
                if (!isPerBoxLabelScenario) {
                  handleGenerateLabel()
                  return
                }
                // The footer does not gate on the session's quality_check at all: that
                // gate is gone (see isSaveDisabled), completeness is enforced by
                // formValid and by the server. A discrepancy here only becomes an
                // override_reason for a user who holds override_packing_quality_check;
                // everyone else concludes with none and lets the server answer
                // quality_check_failed if there really is one.
                // The poll no longer carries quality_check (opt-in: computing
                // it walks every unit and line) — fetch it once, right here,
                // the only place it is read. On a failed fetch send no reason:
                // the backend still rejects with quality_check_failed if there
                // is a real discrepancy, surfaced in the catch below.
                let qcFailed = false
                try {
                  const freshSession = await getPackingSession(packingSessionId, { qualityCheck: true })
                  qcFailed = !!(freshSession?.quality_check && !freshSession.quality_check.ok)
                } catch (qcErr) {
                  // Swallowing this silently made a transient blip on the QC
                  // read indistinguishable from a genuine discrepancy when the
                  // backend then 422s the conclude — leave a trace.
                  console.error('QC pre-read failed before conclude; concluding without override_reason', qcErr)
                  qcFailed = false
                }
                // The server's physical gate makes an unbalanced session unreachable here,
                // so a failed quality check can only be documentary (units unlinked as
                // damaged / not found). Waiving it is a super-admin act behind its own
                // permission; anyone else sends no reason and the server answers
                // quality_check_failed (BUGS-8257).
                const overrideReason =
                  qcFailed && user?.permissions?.override_packing_quality_check ? 'Documentary quality-check override by super admin' : null
                try {
                  await concludePackingSession(packingSessionId, overrideReason)
                  history.push(GENERATE_LABELS.replace(':warehouse_id', warehouse_id))
                } catch (err) {
                  const code = err?.response?.data?.code
                  const friendly = SCAN_ERROR_MESSAGES[code]
                  setErrorMessage(friendly || err?.response?.data?.error || i18n.t('generate_shipment.multi_box.could_not_finalize'))
                }
              }}
              onCancel={() => history.goBack()}
              // The footer used to re-derive this expression inline while the ctrl+g
              // shortcut kept its own copy; the copies drifted and the shortcut became
              // the way around the footer (BUGS-8257). Both entry points now read the
              // same helper, so a sixth gate added there reaches both. WHY each gate is
              // here stays documented below, next to the input it belongs to.
              isSaveDisabled={labelEmissionBlocked({
                // The packed-vs-required check lives in `formValid`, off the local scan
                // count, for every role. The session's quality_check stays out of the
                // button: it lags the poll and also flips on overpacking (949ef6d9). The
                // server enforces completeness on generate_label and conclude (BUGS-8257).
                formValid,
                // Multi-box: footer only enables when ALL paquetes are closed.
                // Each close generates its own packing-list (+ label when the
                // carrier supports per-box generation); the footer either
                // finalizes the order (scenario A) or generates the bulk labels
                // (scenario B).
                multiBoxAwaitingClosedBoxes,
                shouldBlockPreventively,
                packingAuditBlocked,
                // CUBBO-2440: terminal orders load read-only in the beta UI.
                // Before this fix the footer was implicitly disabled: empty
                // sessionBoxes left multiBoxAwaitingClosedBoxes true, one of the
                // clauses of this gate. Now the cajas restore, so gate it
                // explicitly to keep the read-only view from re-concluding an
                // already-shipped order.
                readOnly: useNewPackingUI && packingReadOnly,
              })}
              primaryButtonLabel={(() => {
                if (alreadyHasLabels) return i18n.t('generate_shipment.footer.invalidate_previous_labels')
                if (!useNewPackingUI) return i18n.t('generate_shipment.footer.generate_label')
                // Scenario A vs B is decided by the shipping_method's
                // carrier_supports_per_box_label flag, cross-checked against observed
                // per-box labels so we don't mislabel as scenario B when the flag is
                // missing on a record but labels have been minted. Same derivation the
                // onSave routing and the ctrl+g refusal read, so the label can never
                // promise "Finalizar pedido" while onSave takes the bulk path.
                return isPerBoxLabelScenario ? i18n.t('generate_shipment.footer.finish_order') : i18n.t('generate_shipment.footer.generate_shipping_labels')
              })()}
            />
          }
        >
          {(loading || busyPackageSelection) && (
            <>
              <Loader show={true}></Loader>
            </>
          )}

          <CameraBlockedDialog open={shouldBlockPreventively} onRetry={handleRetryCamera} isRetrying={isRetryingCamera} />

          <PackingAuditBlockedDialog open={packingAuditBlocked} onAcknowledge={handlePackingAuditBlockedAcknowledge} />
          <FulfillmentErrorModal
            open={!!fulfillmentError}
            setOpen={open => {
              if (!open) setFulfillmentError(null)
            }}
            errorCode={fulfillmentError?.code}
            errorCategory={fulfillmentError?.category}
            responsibleArea={fulfillmentError?.responsibleArea}
            flagType={fulfillmentError?.flagType}
            errorMessage={fulfillmentError?.message}
            errorSummary={fulfillmentError?.summary}
            errorDetail={fulfillmentError?.detail}
            retryAfterSeconds={fulfillmentError?.retryAfterSeconds}
            nextCheckAt={fulfillmentError?.nextCheckAt}
            retryCount={fulfillmentError?.retryCount}
            maxRetries={fulfillmentError?.maxRetries}
            onRetry={() => handleGenerateLabel()}
            onWaitElapsed={handleWaitElapsed}
            storeName={shipment?.store_name}
            orderNumber={shipment?.order_number}
            orderId={shipment?.id ?? id}
            tote={shipment?.tote}
            carrierName={effectiveShippingDetails?.shippingMethod?.carrier_name}
            destination={shippingAddress?.zipCode ? `CP ${shippingAddress.zipCode}` : null}
          />

          <ConfirmDialog
            open={openConfirmDialog}
            setOpen={setOpenConfirmDialog}
            title={alreadyHasLabels ? i18n.t('generate_shipment.footer.invalidate_previous_labels') : i18n.t('generate_shipment.footer.generate_label')}
            description={alreadyHasLabels ? i18n.t('generate_shipment.footer.labels_invalidated') : i18n.t('generate_shipment.footer.generate_label_confirm')}
            confirmLabel={i18n.t('generate_shared_label.yes')}
            cancelLabel={i18n.t('dialog.no')}
            onConfirm={() => {
              onConfirmGenerateLabelHandler()
            }}
            loading={confirmLoading}
            loadingLabel={i18n.t('generate_shipment.footer.generating_label')}
          />

          {/* Closing the last open caja with pieces pending. Routine by design: the
              one-caja-at-a-time flow reaches it at nearly every close, so it is a
              plain confirmation, not a danger dialog, and `afterLeave` hands focus
              back to the scan input the way the panel's own confirms do. */}
          <ConfirmDialog
            open={lastBoxCloseConfirm !== null}
            setOpen={() => {
              setLastBoxCloseConfirm(null)
              pendingCloseRunnerRef.current = null
            }}
            title={i18n.t('generate_shipment.multi_box.close_last_box_pending_title')}
            description={i18n.t(
              lastBoxCloseConfirm?.pending === 1
                ? 'generate_shipment.multi_box.close_last_box_pending_one'
                : 'generate_shipment.multi_box.close_last_box_pending_other',
              { count: lastBoxCloseConfirm?.pending ?? 0 },
            )}
            confirmLabel={i18n.t('generate_shipment.multi_box.close_last_box_pending_confirm')}
            cancelLabel={i18n.t('generate_shipment.multi_box.close_last_box_pending_cancel')}
            onConfirm={() => {
              const run = pendingCloseRunnerRef.current
              pendingCloseRunnerRef.current = null
              setLastBoxCloseConfirm(null)
              if (run) run()
            }}
            afterLeave={requestScanFocus}
          />
          <ConfirmDialog
            open={openWarningDialog}
            setOpen={() => {
              setOpenWarningDialog(false)
              setWarningDialogCode(null)
            }}
            title={i18n.t('common.warning')}
            description={
              warningDialogCode ? (
                <>
                  {i18n.t('generate_shipment.product_not_in_order')}
                  <br />
                  <br />
                  <strong>SKU / UPC escaneado:</strong> <code>{warningDialogCode}</code>
                </>
              ) : (
                i18n.t('generate_shipment.product_not_in_order')
              )
            }
            confirmLabel={i18n.t('common.accept')}
            cancelLabel={i18n.t('common.cancel')}
          />

          {/* afterLeave: the packing-list / label preview opens right after
              "Cerrar caja". Headless UI keeps its focus trap + inert on the page
              until the 200ms leave transition ends and then tries to restore the
              focus to the "Cerrar caja" button — which no longer exists (the card
              collapsed) — so nothing is focused. Nudge the scan-focus effect once
              the dialog has really left so the operator can keep scanning. */}
          <DialogView setOpen={setOpenDialogDocument} open={openDialogDocument} afterLeave={requestScanFocus}>
            <LabelView
              title={printInformation.title}
              type={printInformation.type}
              copies={printInformation.type === 'identifier_label' ? effectiveShippingDetails.packages_count : 1}
              file_path={printInformation.file_path}
              bundles={printInformation.bundles}
              is_replenishment_label={printInformation.use_absolute_url || false}
              onCancel={() => {
                if (printInformation.simpleClose || printInformation.type === 'document') setOpenDialogDocument(false)
                else handleClosePreview(false)
              }}

              onPrint={result => {
                // The order is left behind only when every document produced paper; a failed blob
                // or a source the server skipped keeps the operator here.
                if (printInformation.bundles) {
                  if (result?.failed > 0 || printInformation.skipped > 0) return
                  setOpenDialogDocument(false)
                  handleClosePreview(false)
                  return
                }
                setOpenDialogDocument(false)
                // Per-box document chain: if there are more docs queued for this
                // box, open the next one. Walks packing list → etiqueta → factura
                // like the normal end-of-order preview flow.
                if (printInformation.boxDocsQueue?.length) {
                  const [next, ...rest] = printInformation.boxDocsQueue
                  setPrintInformation({
                    ...next,
                    use_absolute_url: true,
                    simpleClose: true,
                    boxDocsQueue: rest,
                  })
                  setOpenDialogDocument(true)
                  return
                }
                // Per-box previews (packing list / shipping label from a single caja)
                // don't chain into the multi-step label-generation cascade — just close
                // and let the operator continue with the next caja.
                if (printInformation.simpleClose) {
                  return
                }

                const nonPrintedDocuments = shippingDocumentsToBePrinted()
                const nonPrintedLabels = shippingLabelsToBePrinted()
                if (nonPrintedLabels.length) {
                  printExtraShippingLabels(nonPrintedLabels[0])
                } else if (
                  shippingDetails.shippingMethod.shipping_type === 'international' &&
                  shippingLabel.billing_file &&
                  !shippingLabel.billing_file.print
                ) {
                  shippingLabel.billing_file.print = true
                  print(i18n.t('generate_shared_label.print_invoice'), shippingLabel.billing_file.path, 'billing')
                } else if (nonPrintedDocuments.length) {
                  printShippingDocument(nonPrintedDocuments[0])
                } else if (shippingLabel.invoice_label_file && shippingLabel.invoice_label_file.path && !shippingLabel.invoice_label_file.print) {
                  shippingLabel.invoice_label_file.print = true
                  print(i18n.t('generate_shared_label.print_invoice_brazil'), shippingLabel.invoice_label_file.path, 'label')
                } else if (!shippingLabel.billing_file && data.shipping_labels[0].billing_file && !data.shipping_labels[0].billing_file.print) {
                  data.shipping_labels[0].billing_file.print = true
                  print(i18n.t('generate_shared_label.print_invoice'), data.shipping_labels[0].billing_file.path, 'billing')
                } else {
                  handleClosePreview(false)
                }
              }}
            />
          </DialogView>

          <PickingOrderToReviewDialog
            setOpen={show => (show ? setOpenDialogRevertPacking({ ...openDialogRevertPacking, show: true }) : closeReviewDialog())}
            open={openDialogRevertPacking.show}
            onCancel={closeReviewDialog}
            onBenchMayHaveChanged={
              packingSessionId
                ? () => {
                    reloadAfterReviewDialogRef.current = true
                  }
                : undefined
            }
            onSuccess={() => {
              if (!goToToteProductScan()) history.goBack()
            }}
            tote={shipment.tote}
            pickingOrderId={pickingOrder?.id}
            productsToReviewById={productsToReviewById}
            eraseShippingData={openDialogRevertPacking.eraseShippingData}
          />
          <ImeiDialog
            setOpen={setOpenDialogImei}
            open={openDialogImei}
            onCancel={() => setOpenDialogImei(false)}
            onSubmit={imei => handleImeiSubmit(imei)}
            imeiValidationRegex={imeiRegex}
          />
          <UnitCodeDialog
            open={openDialogUnitCode}
            setOpen={setOpenDialogUnitCode}
            title={i18n.t('generate_shipment.enter_unit_code')}
            onSubmit={code => handleUnitCodeSubmit(code)}
            onCancel={() => setOpenDialogUnitCode(false)}
            cancelLabel={i18n.t('common.cancel')}
            allowedCodes={unitCodeAllowed}
            alreadyScanned={shipment.productsData.find(pd => pd.product_id === unitCodeReviewedProductId)?.unit_codes || []}
            duplicateMessage={i18n.t('generate_shipment.unit_code_duplicate')}
            notInOrderMessage={i18n.t('generate_shipment.unit_code_not_in_order')}
          />
          <CorreiosDialog
            setOpen={setOpenDialogCorreios}
            open={openDialogCorreios}
            onCancel={() => setOpenDialogCorreios(false)}
            onSubmit={tracking_number => handleCarreiosSubmit(tracking_number)}
          />
          {auditRequired && (
            <div className="mb-4">
              <PackingAuditBanner isCritical={auditCritical} />
            </div>
          )}
          <div className="flex-1 flex items-stretch gap-4">
            <main className="flex-1 flex flex-col gap-4">
              <ShippingAddressSection
                shippingAddress={shippingAddress}
                countyOptions={options}
                onShippingAddressChange={updatedShippingAddress => dispatch(setShippingAddress(updatedShippingAddress))}
                isHidden={!user?.permissions?.wms_show_shipping_address}
                isEditDisabled={
                  !user?.permissions?.wms_edit_shipping_address ||
                  // Beta-only override: in the new flow we lock the address strictly
                  // by whether guías have been minted (shippingLabelsAlreadyMinted),
                  // NOT by the backend's can_order_be_edited flag — that legacy flag
                  // flips to false the moment the order hits 'packing', which would
                  // block scenario-B operators (Estafeta, Natura, etc.) from fixing
                  // the destination before the bulk-generate step.
                  (useNewPackingUI ? shippingLabelsAlreadyMinted : !isEditAllowed)
                }
                editRestrictionTitle={(() => {
                  if (useNewPackingUI) {
                    return shippingLabelsAlreadyMinted ? i18n.t('generate_shipment.edit_restriction.title') : null
                  }
                  return !isEditAllowed ? i18n.t('generate_shipment.edit_restriction.title') : null
                })()}
                editRestrictionMessage={(() => {
                  if (useNewPackingUI) {
                    return shippingLabelsAlreadyMinted ? i18n.t('generate_shipment.multi_box.address_frozen_after_labels') : null
                  }
                  if (!isEditAllowed) {
                    return editRestrictionReason
                      ? i18n.t(`generate_shipment.restriction_reasons.${editRestrictionReason}`) !==
                        `generate_shipment.restriction_reasons.${editRestrictionReason}`
                        ? i18n.t(`generate_shipment.restriction_reasons.${editRestrictionReason}`)
                        : i18n.t('generate_shipment.edit_restriction.default_message')
                      : i18n.t('generate_shipment.edit_restriction.default_message')
                  }
                  return null
                })()}
              />

              <ProductListSection
                products={productsToReviewById}
                productSearchRef={inputRef}
                // Scope the read-only scan lock to the beta packing UI — the
                // terminal-order session flow only runs for beta users, so the
                // legacy scan input must keep working for everyone else.
                searchDisabled={useNewPackingUI && packingReadOnly}
                onSearchChange={value => addProducts(value)}
                productSearchDependencies={productsToReviewById}
                productSearchAlertMsg={alert}
                // A piece that takes a unit code can be scanned by that code alone.
                acceptsUnitCode={!isRemoveStockOrder && Object.values(productsToReviewById).some(p => p.requires_unit_code && !p.has_imei)}
                latestAddedProduct={latestAddedProduct}
                className={'mt-5'}
                activePackageLabel={(() => {
                  const activeBox = sessionBoxes[activeBoxIdx]
                  if (!useNewPackingUI || !activeBox || activeBox.is_closed) return null
                  const n = paqueteNumberByBoxId[activeBox.id]
                  return n ? i18n.t('generate_shipment.multi_box.active_box_label', { n }) : null
                })()}
                boxesBreakdown={
                  useNewPackingUI
                    ? (() => {
                        // Per-product distribution across Paquetes + tote. Uses the
                        // shared resolveUnitProductId ladder so kit_child SKUs and
                        // UPC-resolved packed_units land on the right review row
                        // (was previously accepting kit parent ids that don't exist
                        // in productsToReviewById → units silently attributed to
                        // "en el tote" even when already packed).
                        const breakdown = {}
                        const perProductPerBox = {}
                        // Per-box closed flag keyed by the stable box id — used in the
                        // pills to visually distinguish closed cajas from open ones.
                        // Keying by id (not array index) keeps the pills aligned with
                        // the same "Paquete N" numbering the cards + header use.
                        const boxClosedById = {}
                        for (const box of packingSession?.packing_boxes || []) {
                          boxClosedById[box.id] = !!(box.is_closed || box.status === 'closed')
                          for (const u of box.packed_units || []) {
                            if (u._optimistic || u._synthetic) continue
                            const productId = resolveUnitProductId(u)
                            if (!productId) continue
                            if (!perProductPerBox[productId]) perProductPerBox[productId] = {}
                            perProductPerBox[productId][box.id] = (perProductPerBox[productId][box.id] || 0) + 1
                          }
                        }
                        // Now produce the breakdown keyed by the same SKU the table renders.
                        for (const product of Object.values(productsToReviewById)) {
                          const sku = skuForProduct(product)
                          const perBoxMap = perProductPerBox[product.id] || {}
                          const perBox = Object.entries(perBoxMap)
                            .map(([boxId, count]) => ({
                              // Discarded boxes carry no units, so they never reach
                              // here; boxNumber is the shared paquete number.
                              boxNumber: paqueteNumberByBoxId[boxId],
                              count,
                              isClosed: !!boxClosedById[boxId],
                            }))
                            .filter(({ count, boxNumber }) => count > 0 && boxNumber != null)
                            .sort((a, b) => a.boxNumber - b.boxNumber)
                          const inBoxesTotal = perBox.reduce((s, { count }) => s + count, 0)
                          const inTote = Math.max(0, (product.quantity || 0) - inBoxesTotal)
                          breakdown[sku] = { perBox, inTote }
                        }
                        return breakdown
                      })()
                    : null
                }
              />

              {auditRequired && validQualityCheck && !auditLocallyAnswered && (
                <PackingAuditQuestions orderId={data?.id} scansCount={scansCount} onAnswered={() => setAuditLocallyAnswered(true)} />
              )}

              {auditRequired && auditLocallyAnswered && (
                <div className="bg-green-50 border border-green-200 rounded-lg p-4 text-green-700 font-medium">
                  {i18n.t('packing_audit.answered_confirmation')}
                </div>
              )}

              <InsertsSection orderLines={data?.order_lines} className={'mt-5'} />

              {asyncGeneratedPendingLabels && !asyncGeneratedPrintableLabels && (
                <div className="mt-5 bg-yellow-50 border border-yellow-200 rounded-lg p-4 text-yellow-700 font-medium">
                  {i18n.t('generate_shipment.label_being_generated')}
                </div>
              )}

              <ShippingLabelsListSection
                shippingLabels={data?.shipping_labels}
                meliShipmentId={data?.meli_shipment_id}
                coverageReassignment={data?.coverage_reassignment}
                onPrintLabel={labelFile => print(i18n.t('generate_shipment.print_label'), labelFile.path, 'label', { simpleClose: true })}
                isHidden={!(alreadyHasLabels || asyncGeneratedPrintableLabels)}
                className={'mt-5'}
              />

              <AttachmentsListSection
                shippingDocuments={shippingDocuments}
                onPrintDocument={documentFile => print(i18n.t('generate_shipment.print_titles.shipping_documents'), documentFile.path, 'document')}
                isHidden={!(shippingDocuments?.length > 0 && shipment?.status === 'shipped')}
              />
            </main>

            <aside className="w-5/12 border-gray-200 flex flex-col gap-4">
              <MissingPickingPiecesSection
                isHidden={!user.permissions?.put_picking_order_in_review || data?.uses_picking_tasks}
                onSubmitOrderForReview={eraseShippingData => setOpenDialogRevertPacking({ show: true, eraseShippingData: eraseShippingData })}
                // The address form, plus three refusals the operator cannot act on. Via
                // formValid this ALSO required valid shipping packages, a complete audit
                // scan and a complete piece count; those three stay out ON PURPOSE
                // (f0c237a6) — demanding them in order to REPORT missing pieces is the
                // dead end this ticket removes, since validQualityCheck can never be true
                // while pieces really are missing, and the section titled "¿Faltaron
                // piezas por pickear?" went dark in exactly the case it exists for.
                // Do not "restore" them. The three that belong here:
                //   - busyPackageSelection: a package-selection request is in flight, and
                //     sending the order back to picking while it is pending lets the
                //     response land on an order that has already left packing.
                //   - packingReadOnly (terminal order) and the picking order already in
                //     review: put_in_review refuses both outright, so the button should be
                //     off rather than send the operator into a server error.
                isSubmitOrderForReviewDisabled={!validateShippingAddressForm || busyPackageSelection || packingReadOnly || Boolean(pickingOrder?.in_review)}
              />

              {cameraBlockedMessage !== null && !shouldBlockPreventively && (
                <CameraBlockedBanner message={cameraBlockedMessage} onRetry={handleRetryCamera} isRetrying={isRetryingCamera} />
              )}

              {labelPending && (
                <LabelPendingBanner estimatedSeconds={labelPending.estimatedSeconds} startedAt={labelPending.startedAt} waitReason={labelPending.waitReason} />
              )}

              <FulfillmentErrorBannerSection fulfillmentErrors={data?.order_fulfillment_errors} />

              <MissingInfoNotificationSection isMissingInfo={!validateShippingAddressForm} />

              <GeneratedLabelNotificationSection isShippingLabelGenerated={alreadyHasLabels} />

              {!useNewPackingUI && (
                <FragileNotificationSection
                  isFragileOrder={isFragileOrder}
                  warehousePackingMaterials={warehousePackingMaterialsData?.warehouse_packing_materials}
                  storePackingMaterials={storePackingMaterialsData?.store_packing_materials}
                />
              )}

              <CodNotificationSection isCodOrder={data?.is_cod} totalOrderPrice={data?.total_price} currency={data?.currency} />

              {!useNewPackingUI && (
                <RecommendedPackageSection
                  availablePackageOptions={packingOptions?.store_packing_options}
                  isPackagelessOrder={isPackagelessOrder}
                  isFragileOrder={isFragileOrder}
                />
              )}

              {useNewPackingUI && (
                <MultiBoxPackingPanel
                  boxes={sessionBoxes}
                  canBulkAdd={bulkAddAllowed(data, bulkAddRevoked)}
                  activeBoxIdx={activeBoxIdx}
                  onCardDialogOpenChange={handleCardDialogOpenChange}
                  onRequestScanFocus={requestScanFocus}
                  shippingPackagesByBoxIdx={(() => {
                    // Empaque shown per card, indexed to line up with
                    // `sessionBoxes` (the same idx the panel hands back to the
                    // handlers). For an EXISTING box the empaque is ALWAYS the
                    // box's own backend `shipping_package_id` — the bag it was
                    // created with — never the Redux slot, which can be
                    // missing/misaligned (holes left by discarded boxes) and
                    // would make an already-opened box render "Selecciona el
                    // empaque" and HIDE its scanned pieces (BUGS-7438 follow-up:
                    // ANGU showed "1×Paquete 2" in the list while the Paquete 2
                    // card looked empty). Only a virtual placeholder slot (no box
                    // yet, awaiting its first empaque) reads Redux.
                    const fromRedux = shippingDetails?.packages || []
                    const pkgData = shippingPackages?.data || []
                    const resolveBoxPkg = b => {
                      const pkgId = b?.shipping_package_id ?? b?.shipping_package?.id ?? null
                      return pkgId ? pkgData.find(p => p.id === pkgId) || null : null
                    }
                    const length = Math.max(sessionBoxes.length, fromRedux.length)
                    return Array.from({ length }, (_, i) => {
                      const box = sessionBoxes[i]
                      return box ? resolveBoxPkg(box) : fromRedux[i] || null
                    })
                  })()}
                  productNameBySku={(() => {
                    const map = {}
                    Object.values(productsToReviewById).forEach(p => {
                      const sku = p.product_codes?.find(pc => pc.sku)?.sku
                      if (sku) map[sku] = p.name || p.product_name || ''
                    })
                    for (const box of packingSession?.packing_boxes || []) {
                      for (const u of box.packed_units || []) {
                        const key = packedUnitKey(u)
                        if (key && !map[key] && u.description) map[key] = u.description
                      }
                    }
                    return map
                  })()}
                  productFragileBySku={(() => {
                    const map = {}
                    for (const line of data?.order_lines || []) {
                      const sku = line.product?.product_codes?.find(pc => pc.sku)?.sku
                      if (sku && line.product?.is_fragile) map[sku] = true
                      for (const kc of line.kit_childs || []) {
                        const kSku = kc.child_product?.product_codes?.find(pc => pc.sku)?.sku
                        if (kSku && kc.child_product?.is_fragile) map[kSku] = true
                      }
                    }
                    return map
                  })()}
                  isFragileOrder={isFragileOrder}
                  availableShippingMethods={cubboShippingMethods?.data || []}
                  selectedShippingMethod={shippingDetails?.shippingMethod || data?.shipping_method || null}
                  isShippingMethodEditable={
                    // Lock the paquetería only once guías have actually been
                    // minted — scenario B (Estafeta, Natura, etc.) closes just
                    // produce packing lists, and the operator may still need
                    // to swap the carrier before the bulk-generate step.
                    canEditShippingMethod && !shippingLabelsAlreadyMinted
                  }
                  supportsPerBoxLabel={(shippingDetails?.shippingMethod || data?.shipping_method)?.carrier_supports_per_box_label ?? null}
                  allowCloseWithoutItems={hasNoScannableItems}
                  onSelectShippingMethod={newShippingMethod => {
                    dispatch(setShippingDetails({ ...shippingDetails, shippingMethod: newShippingMethod || null }))
                  }}
                  storePackingOptions={packingOptions?.store_packing_options}
                  availableShippingPackages={shippingPackages?.data}
                  isPackagelessOrder={isPackagelessOrder}
                  hasPackagelessProduct={hasPackagelessProduct}
                  orderStoreId={data?.store?.id}
                  focusPackageComboboxSignal={packageFocusSignal}
                  onSelectEmpaque={async (boxIdx, pkg) => {
                    // Resolve the FULL package object (with dimensions /
                    // volumetric_weight) from `shippingPackages.data`. The combobox
                    // sometimes hands us a partial that fails
                    // `areShippingPackagesValid` → footer button stays disabled.
                    const fullPkg = pkg && pkg.id ? (shippingPackages?.data || []).find(p => p.id === pkg.id) || pkg : pkg
                    const existingBox = sessionBoxes[boxIdx]
                    if (existingBox) {
                      // EXISTING box → PATCH the backend only; NEVER write the
                      // Redux `packages` slot here. Writing a slot at boxIdx made
                      // the lazy-open effect read it as "a new position needs a
                      // box" and spuriously opened one (BUGS-7438: picking an
                      // empaque auto-opened "Paquete 3"). The card's empaque now
                      // renders straight from the box's shipping_package_id, which
                      // this PATCH updates. No-op when the empaque is unchanged.
                      if (pkg?.id && existingBox.shipping_package_id !== pkg.id) {
                        try {
                          const updatedBox = await updatePackingBoxShippingPackage(existingBox.id, pkg.id)
                          queryClient.setQueryData(['packingSession', packingSessionId], old => {
                            if (!old) return old
                            return {
                              ...old,
                              packing_boxes: (old.packing_boxes || []).map(b => (b.id === updatedBox.id ? { ...b, ...updatedBox } : b)),
                            }
                          })
                        } catch (err) {
                          setErrorMessage(resolvePackingErrorMessage(err, SCAN_ERROR_MESSAGES, i18n.t('generate_shipment.multi_box.could_not_change_empaque')))
                          // The empaque did NOT change — leave the focus in the
                          // combobox so the operator can pick again.
                          return
                        }
                      }
                      // Picked (or re-picked) the empaque of an existing caja:
                      // the next action is scanning → make THIS caja the scan
                      // target before handing the focus back (see the scan-focus
                      // effect). Focus and target must move together: the focus
                      // alone would route the next piece into whatever caja was
                      // active while the operator's attention is on this one.
                      // (Mouse picks activate the card via handleCardClick, but a
                      // keyboard/scanner pick straight into the combobox input
                      // never fires it.) Headless UI would otherwise keep the
                      // focus in the combobox.
                      if (existingBox.id !== activeBoxIdRef.current) {
                        setActiveBoxId(existingBox.id)
                      }
                      requestScanFocus()
                      return
                    }
                    // VIRTUAL placeholder slot (added via "Añadir otra caja", no
                    // backend box yet) → record the empaque in Redux so the box is
                    // opened for it. This is the ONLY path that creates a box.
                    const next = [...(shippingDetails?.packages || [])]
                    next[boxIdx] = fullPkg || null
                    dispatch(setShippingDetails({ ...shippingDetails, packages: next }))
                  }}
                  onCloseBox={async boxIdx => {
                    const box = sessionBoxes[boxIdx]
                    if (!box) return
                    // Pre-check: read FRESH state from the cache. The card might
                    // have re-rendered with stale props (reorder moves the card,
                    // closingInFlight resets); without this guard a double-click
                    // can land a second /close on a box that is already closed,
                    // surfacing "Box N is already closed" from the backend.
                    const cached = queryClient.getQueryData(['packingSession', packingSessionId])
                    const liveBox = (cached?.packing_boxes || []).find(b => b.id === box.id)
                    if (liveBox?.is_closed || liveBox?.status === 'closed') return
                    if (closingBoxIdsRef.current.has(box.id)) return // in-flight
                    // Closing the only open caja with pieces pending used to leave the
                    // operator with nothing to scan into and no visible way forward; they
                    // read it as "the order closed" and reported a bug. So ask first.
                    //
                    // Operators work one caja at a time, so this question is routine, not
                    // an alarm: on a 50-piece order packed 5 at a time it is asked at
                    // nearly every close. It is phrased and styled as a normal
                    // confirmation for that reason — an alarm asked nine times is an alarm
                    // nobody reads. And it does NOT promise a specific way back: whether
                    // "+ Añadir otra caja" exists depends on the shipping method's
                    // enable_multipackage, so reopening this caja is the only universal
                    // exit and the copy names both without claiming which one is offered.
                    const pending = pendingPiecesCount(productsToReviewById)
                    const runClose = async () => {
                      closingBoxIdsRef.current.add(box.id)
                      try {
                        // Pass the currently-selected paquetería + the destination
                        // (shipping address). Backend snapshots both at close time
                        // and uses the carrier to decide scenario A vs B. After the
                        // first close we lock both fields in the UI so subsequent
                        // cajas don't desync from the labels already produced.
                        const selectedShippingMethodId = shippingDetails?.shippingMethod?.id || data?.shipping_method?.id || null
                        const updated = await closePackingBox(box.id, {
                          shippingMethodId: selectedShippingMethodId,
                          shippingAddress: shippingAddress || null,
                        })
                        queryClient.setQueryData(['packingSession', packingSessionId], old => {
                          if (!old) return old
                          return {
                            ...old,
                            packing_boxes: (old.packing_boxes || []).map(b => (b.id === updated.id ? { ...b, ...updated } : b)),
                          }
                        })
                        // Scenario A: backend returns shipping_label_url at close.
                        // Scenario B: only packing_list_url; bulk labels come later
                        // via the footer button. BR orders also get invoice_url
                        // (NF-e) — same invoice for every box of the order. The
                        // preview walks through every doc the backend returned, in
                        // the same order as the normal end-of-order flow.
                        const closedBox = { ...box, ...updated }
                        const docs = buildBoxDocsQueue(closedBox, boxIdx)
                        if (docs.length) {
                          const [first, ...rest] = docs
                          setPrintInformation({
                            ...first,
                            use_absolute_url: true,
                            simpleClose: true,
                            boxDocsQueue: rest,
                          })
                          setOpenDialogDocument(true)
                        }
                      } catch (err) {
                        // "Already closed" → idempotent success. The backend (or
                        // another operator / a duplicate click that slipped past
                        // the guards) already closed the box. Just resync the cache
                        // and don't show an error.
                        const status = err?.response?.status
                        const code = err?.response?.data?.code
                        const message = err?.response?.data?.error || ''
                        const alreadyClosed = code === 'box_closed' || code === 'box_already_closed' || /already\s*closed/i.test(message)
                        if (alreadyClosed) {
                          queryClient.invalidateQueries(['packingSession', packingSessionId])
                          return
                        }
                        const friendly = SCAN_ERROR_MESSAGES[code]
                        setErrorMessage(friendly || message || i18n.t('generate_shipment.multi_box.could_not_close_box'))
                      } finally {
                        closingBoxIdsRef.current.delete(box.id)
                      }
                    }
                    if (closingLastBoxWithPending({ boxes: sessionBoxes, boxId: box.id, pendingPieces: pending })) {
                      // Park the close and ask. The runner is held in a ref rather than
                      // state so answering it cannot race a re-render of the card.
                      pendingCloseRunnerRef.current = runClose
                      setLastBoxCloseConfirm({ pending })
                      return
                    }
                    await runClose()
                  }}
                  onDeleteCaja={async boxIdx => {
                    // Hard-delete via the dedicated DELETE endpoint — releases
                    // the box's packed_units back to PICKED stock and invalidates
                    // any minted carrier label. Then drop the package slot at the
                    // same index in Redux so remaining cards keep their empaques.
                    // For beta we keep packages_count >= 1 (the new panel always
                    // renders at least one placeholder PAQUETE 1 even when no
                    // backend box exists yet).
                    const box = sessionBoxes[boxIdx]
                    try {
                      if (box) {
                        await deletePackingBox(box.id)
                        queryClient.setQueryData(['packingSession', packingSessionId], old => {
                          if (!old) return old
                          return {
                            ...old,
                            packing_boxes: (old.packing_boxes || []).filter(b => b.id !== box.id),
                          }
                        })
                      }
                      const currentPackages = shippingDetails?.packages || []
                      const currentCount = shippingDetails?.packages_count || currentPackages.length || 1
                      const nextPackages = currentPackages.filter((_, i) => i !== boxIdx)
                      // Floor packages_count at 1 so the placeholder PAQUETE 1
                      // is always rendered in the new panel.
                      const nextCount = Math.max(1, currentCount - 1)
                      dispatch(
                        setShippingDetails({
                          ...shippingDetails,
                          packages: nextPackages,
                          packages_count: nextCount,
                        }),
                      )
                      setPackagesExternalVersion(v => v + 1)
                    } catch (err) {
                      const code = err?.response?.data?.code
                      const friendly = SCAN_ERROR_MESSAGES[code]
                      setErrorMessage(friendly || err?.response?.data?.error || i18n.t('generate_shipment.multi_box.could_not_delete_box'))
                    }
                  }}
                  onAddNewBox={() => {
                    const currentCount = shippingDetails?.packages_count || 1
                    dispatch(
                      setShippingDetails({
                        ...shippingDetails,
                        packages_count: currentCount + 1,
                        packages: [...(shippingDetails?.packages || []), null],
                      }),
                    )
                  }}
                  onRemoveOne={removeProductFromBox}
                  onAddBulk={async (boxIdx, sku, count) => {
                    const box = sessionBoxes[boxIdx]
                    if (!box) return
                    // Resolve productId for the bumped reviewedItemsCount path.
                    const productByCode = Object.values(productsToReviewById).find(p => p.product_codes?.some(pc => pc.sku === sku || pc.upc === sku))
                    const productId = productByCode?.id || null
                    try {
                      const { summary, box: updatedBox } = await bulkScanIntoBox(box.id, sku, count)
                      queryClient.setQueryData(['packingSession', packingSessionId], old => {
                        if (!old) return old
                        return {
                          ...old,
                          packing_boxes: (old.packing_boxes || []).map(b => (b.id === updatedBox.id ? { ...b, ...updatedBox } : b)),
                        }
                      })
                      const packed = summary?.packed || 0
                      if (productId && productsToReviewById[productId] && packed > 0) {
                        productsToReviewById[productId].reviewedItemsCount = (productsToReviewById[productId].reviewedItemsCount || 0) + packed
                        setProductsToReviewById({ ...productsToReviewById })
                      }
                      // Partial-success path: backend returned 200 but packed
                      // fewer units than requested (not enough PICKED, etc).
                      if (summary && summary.packed < summary.requested) {
                        const skipped = summary.skipped || {}
                        const reasons = []
                        if (skipped.already_packed_in_another_box) reasons.push(i18n.t('generate_shipment.multi_box.bulk_add_skipped_already_packed', { n: skipped.already_packed_in_another_box }))
                        if (skipped.not_enough_picked_units) reasons.push(i18n.t('generate_shipment.multi_box.bulk_add_skipped_not_picked', { n: skipped.not_enough_picked_units }))
                        setAlert(i18n.t('generate_shipment.multi_box.bulk_add_partial', { packed: summary.packed, requested: summary.requested }) + (reasons.length ? ` (${reasons.join(', ')})` : ''))
                      }
                    } catch (err) {
                      if (isBulkAddDisabledError(err)) setBulkAddRevoked(true)
                      const code = err?.response?.data?.code
                      const friendly = SCAN_ERROR_MESSAGES[code]
                      setErrorMessage(friendly || err?.response?.data?.error || i18n.t('generate_shipment.multi_box.could_not_add_units'))
                    }
                  }}
                  onRemoveBulk={async (boxIdx, sku, count) => {
                    // Atomic bulk-unscan (backend PR #3727). Goes from N
                    // serial /unscan calls to 1 request. Partial success
                    // (less packed than requested) returns 200 with the
                    // shortage in summary.skipped — no error.
                    const box = sessionBoxes[boxIdx]
                    if (!box) return
                    const product = Object.values(productsToReviewById).find(
                      p => skuForProduct(p) === sku || p?.product_codes?.some(pc => pc.sku === sku || pc.upc === sku || pc.bar_code === sku),
                    )
                    // Validate per backend contract (1..1000).
                    const clamped = Math.max(1, Math.min(1000, Math.floor(count)))
                    try {
                      const { summary, box: updatedBox } = await bulkUnscanFromBox(box.id, sku, clamped)
                      queryClient.setQueryData(['packingSession', packingSessionId], old => {
                        if (!old) return old
                        return {
                          ...old,
                          packing_boxes: (old.packing_boxes || []).map(b => (b.id === updatedBox.id ? { ...b, ...updatedBox } : b)),
                        }
                      })
                      const unscanned = summary?.unscanned || 0
                      if (product && unscanned > 0) {
                        productsToReviewById[product.id].reviewedItemsCount = Math.max(
                          0,
                          (productsToReviewById[product.id].reviewedItemsCount || 0) - unscanned,
                        )
                        setProductsToReviewById({ ...productsToReviewById })
                      }
                      // Partial — warn the operator about the shortage so they
                      // know not all requested units came out (e.g. they asked
                      // for 5 but only 3 were packed).
                      const shortage = (summary?.requested || 0) - unscanned
                      if (shortage > 0) {
                        setAlert(
                          i18n.t('generate_shipment.multi_box.bulk_unscan_partial', {
                            unscanned,
                            requested: summary?.requested || clamped,
                          }),
                        )
                      }
                    } catch (err) {
                      const code = err?.response?.data?.code
                      // Backend says this product needs per-unit removal —
                      // fall back to a serial /unscan loop. /unscan is now
                      // idempotent so the loop is safe and simple.
                      if (code === 'unit_tracked_not_bulkable' || code === 'imei_requires_individual_scan') {
                        let removed = 0
                        for (let i = 0; i < clamped; i++) {
                          const cached = queryClient.getQueryData(['packingSession', packingSessionId])
                          const liveBox = (cached?.packing_boxes || []).find(b => b.id === box.id)
                          if (!liveBox) break
                          const liveCandidates = (liveBox.packed_units || []).filter(u => !u._synthetic && !u._optimistic && packedUnitKey(u) === sku)
                          if (!liveCandidates.length) break
                          const target = liveCandidates[liveCandidates.length - 1]
                          try {
                            const updated = await unscanUnit(box.id, target.id)
                            queryClient.setQueryData(['packingSession', packingSessionId], old => {
                              if (!old) return old
                              return {
                                ...old,
                                packing_boxes: (old.packing_boxes || []).map(b => (b.id === updated.id ? { ...b, ...updated } : b)),
                              }
                            })
                            removed++
                          } catch (_) {
                            break
                          }
                        }
                        if (product && removed > 0) {
                          productsToReviewById[product.id].reviewedItemsCount = Math.max(
                            0,
                            (productsToReviewById[product.id].reviewedItemsCount || 0) - removed,
                          )
                          setProductsToReviewById({ ...productsToReviewById })
                        }
                        return
                      }
                      const friendly = SCAN_ERROR_MESSAGES[code]
                      setErrorMessage(friendly || err?.response?.data?.error || i18n.t('generate_shipment.multi_box.could_not_unscan'))
                    }
                  }}
                  onPrintBoxPackingList={boxIdx => startBoxDocsChain(boxIdx, 'packing_list')}
                  onPrintShippingLabel={boxIdx => startBoxDocsChain(boxIdx, 'shipping_label')}
                  onPrintBoxInvoice={boxIdx => startBoxDocsChain(boxIdx, 'invoice')}
                  onSelectActiveBox={boxIdx => {
                    // Allow switching active caja only when it's a real, open box.
                    // Virtual placeholders (boxIdx beyond sessionBoxes) and closed
                    // boxes are ignored — closed boxes don't accept scans.
                    const box = sessionBoxes[boxIdx]
                    if (box && !box.is_closed) setActiveBoxId(box.id)
                  }}
                  onReopenBox={async boxIdx => {
                    // Reopen a closed caja so the operator can correct mistakes
                    // (wrong count, wrong empaque). Backend (PR #3727):
                    // - invalidates the carrier label
                    // - keeps the packing-list label (PDF refreshes on next close)
                    // - status → 'processing' (if had units) or 'open' (if empty)
                    // - idempotent: reopening an already-open box is a 200 no-op
                    // - 422 'session_concluded' if order already shipped
                    const box = sessionBoxes[boxIdx]
                    if (!box) return
                    try {
                      const updated = await reopenPackingBox(box.id)
                      queryClient.setQueryData(['packingSession', packingSessionId], old => {
                        if (!old) return old
                        return {
                          ...old,
                          packing_boxes: (old.packing_boxes || []).map(b =>
                            b.id === updated.id
                              ? {
                                  ...b,
                                  ...updated,
                                  // Hard-null the carrier label URL — the print
                                  // button must NOT stay visible pointing to a
                                  // label that the backend just invalidated.
                                  // Keep packing_list_url since the backend
                                  // preserves it (refreshes on next close).
                                  shipping_label_url: null,
                                }
                              : b,
                          ),
                        }
                      })
                      // Make this caja the active one again so subsequent
                      // scans flow into it without another click.
                      setActiveBoxId(updated.id)
                    } catch (err) {
                      const code = err?.response?.data?.code
                      if (code === 'session_concluded') {
                        setErrorMessage(i18n.t('generate_shipment.multi_box.reopen_session_concluded'))
                        return
                      }
                      if (err?.response?.status === 404) {
                        setErrorMessage(i18n.t('generate_shipment.multi_box.reopen_not_available_yet'))
                        return
                      }
                      setErrorMessage(err?.response?.data?.error || i18n.t('generate_shipment.multi_box.could_not_reopen_box'))
                    }
                  }}
                  canAddNewBox={
                    backendSwitchesForMultiGuide(data) ||
                    (shippingDetails?.shippingMethod || data?.shipping_method)?.enable_multipackage === true
                  }
                  readOnly={packingReadOnly}
                />
              )}

              {!useNewPackingUI && (
                <ShippingPackageDataSection
                  key={`${restoredPackagesSnapshot ? `restored-${restoredPackagesSnapshot.sessionId}` : 'fresh'}-${packagesExternalVersion}`}
                  initialPackageQuantity={
                    // When we externally mutate the package set (e.g. on "Eliminar caja"),
                    // remount using whatever's currently in Redux to stay in sync.
                    packagesExternalVersion > 0
                      ? shippingDetails?.packages_count || 1
                      : restoredPackagesSnapshot
                        ? restoredPackagesSnapshot.packages.length
                        : orderPackageRestrictions.package_quantity
                          ? orderPackageRestrictions.package_quantity
                          : 1
                  }
                  initialShippingPackages={
                    packagesExternalVersion > 0
                      ? shippingDetails?.packages || []
                      : restoredPackagesSnapshot
                        ? restoredPackagesSnapshot.packages
                        : orderRecommendedShippingPackages.shipping_packages
                  }
                  isPackageQuantityEditable={orderPackageRestrictions.package_quantity ? false : true}
                  onPackageNumberChange={(newPackagesCount, newShippingPackages) => {
                    // console.log("onPackageNumberChange", newPackagesCount, newShippingPackages)
                    dispatch(
                      setShippingDetails({
                        ...shippingDetails,
                        packages: [...newShippingPackages],
                        packages_count: enforcePackagesCountLimit(newPackagesCount, shippingDetails.packages_count),
                      }),
                    )
                  }}
                  onShippingMethodChange={(newShippingMethod, newPackageQuantity, newShippingPackages) => {
                    console.log('onShippingMethodChange', newShippingMethod, newPackageQuantity, newShippingPackages)
                    // console.log("onShippingMethodChange shippingDetails", shippingDetails)
                    dispatch(
                      setShippingDetails({
                        ...shippingDetails,
                        shippingMethod: newShippingMethod,
                        packages: newShippingPackages !== undefined ? [...newShippingPackages] : shippingDetails.packages,
                        packages_count:
                          newPackageQuantity !== undefined && newPackageQuantity !== null
                            ? enforcePackagesCountLimit(newPackageQuantity, shippingDetails.packages_count)
                            : shippingDetails.packages_count,
                      }),
                    )
                  }}
                  onShippingPackageChange={newShippingPackages => {
                    // console.log("onShippingPackageChange", newShippingPackages)
                    dispatch(
                      setShippingDetails({
                        ...shippingDetails,
                        packages: [...newShippingPackages],
                      }),
                    )
                  }}
                  initialShippingMethod={data?.shipping_method}
                  availableShippingMethods={cubboShippingMethods?.data}
                  availableShippingPackages={shippingPackages?.data}
                  storePackingOptions={packingOptions?.store_packing_options}
                  orderWarehouseId={data?.warehouse_id}
                  orderStoreId={data?.store?.id}
                  isPackagelessOrder={isPackagelessOrder}
                  hasPackagelessProduct={hasPackagelessProduct}
                  isFragileOrder={isFragileOrder}
                  isShippingMethodEditable={canEditShippingMethod}
                  shippingMethodOptions={cubboShippingMethods?.data}
                  disableMultiPackageAutoSelect={data?.is_cod || isInternationalOrder}
                  orderCanRecalculateShippingMethod={data?.channel_name && data?.channel_name !== 'manual'}
                  onBusyChange={isBusy => setBusyPackageSelection(isBusy)}
                  orderId={data?.id}
                  focusPackageComboboxSignal={packageFocusSignal}
                />
              )}

              <InternationalNotificationSection isInternationalOrder={isInternationalOrder} />
            </aside>
          </div>
        </PageView>
      )}
    </>
  )
}
